{
  "common": {
    "loading": "Chargement...",
    "error": "Erreur",
    "retry": "Réessayer",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "saving": "Enregistrement...",
    "close": "Fermer",
    "back": "Retour",
    "next": "Suivant",
    "search": "Rechercher",
    "watchNow": "Regarder maintenant",
    "playNow": "Lire maintenant",
    "play": "Lire",
    "moreInfo": "Plus d'infos",
    "seeAll": "Voir tout",
    "new": "Nouveau",
    "live": "EN DIRECT",
    "recommended": "Recommandé",
    "edit": "Modifier",
    "delete": "Supprimer",
    "add": "Ajouter",
    "enabled": "Activé",
    "disabled": "Désactivé",
    "invalidDate": "Date invalide",
    "appName": "🏠 Bayit+",
    "appVersion": "🏠 Bayit+ v1.0.0",
    "slogan": "Votre Maison. Partout.",
    "ok": "OK",
    "success": "Succès",
    "warning": "Avertissement",
    "confirm": "Confirmer",
    "yes": "Oui",
    "no": "Non",
    "apply": "Appliquer",
    "errors": {
      "unexpected": "Une erreur inattendue s'est produite"
    },
    "send": "Envoyer",
    "done": "Terminé",
    "all": "Tout",
    "reset": "Réinitialiser",
    "deleting": "Suppression...",
    "noResults": "Aucun résultat trouvé",
    "tryDifferentSearch": "Essayez un autre terme de recherche",
    "previous": "Précédent",
    "actions": "Actions",
    "pageOf": "Page {{page}} sur {{total}}",
    "noData": "Aucune donnée disponible",
    "filters": "Filtres",
    "clear": "Effacer",
    "clearSelection": "Effacer",
    "expand": "Développer",
    "collapse": "Réduire",
    "upgrade": "Passer à Premium",
    "skip": "Passer",
    "thisContent": "ce contenu",
    "backToHome": "Retour à l'accueil",
    "dismiss": "Fermer",
    "goBack": "Retour",
    "pause": "Pause",
    "tryAgain": "Reessayer",
    "refresh": "Actualiser"
  },
  "culturalContext": {
    "loading": "Chargement de l'explication...",
    "loadError": "Échec du chargement de l'explication",
    "related": "Références associées"
  },
  "demo": {
    "banner": "MODE DÉMO",
    "bannerSubtext": "Utilisation de données simulées - Pas d'appels API",
    "days": {
      "sunday": "Dimanche",
      "monday": "Lundi",
      "tuesday": "Mardi",
      "wednesday": "Mercredi",
      "thursday": "Jeudi",
      "friday": "Vendredi",
      "saturday": "Samedi"
    },
    "shabbat": "Chabbat",
    "until_shabbat": "Jusqu'au Shabbat",
    "search_interpretation": "Recherche pour \"{{query}}\"",
    "suggestions": {
      "0": "Fauda",
      "1": "Shtisel",
      "2": "Téhéran",
      "3": "L'Arbitre",
      "4": "Travail"
    },
    "premium_plan": "Premium",
    "assistant_response": "Je recommande Fauda - une excellente série à suspense !",
    "morning_greeting": "Bonjour ! Le temps est agréable aujourd'hui, il y a des nouvelles importantes d'Israël, et j'ai sélectionné du contenu spécialement pour vous."
  },
  "hero": {
    "watch": "Regarder",
    "moreInfo": "Plus d'infos",
    "addToList": "Ajouter à la liste"
  },
  "login": {
    "title": "Bon retour",
    "subtitle": "Connectez-vous pour continuer sur Bayit+",
    "tagline": "Votre Maison aux États-Unis",
    "email": "E-mail",
    "emailPlaceholder": "Entrez votre e-mail",
    "password": "Mot de passe",
    "passwordPlaceholder": "Entrez votre mot de passe",
    "submit": "Se connecter",
    "loggingIn": "Connexion en cours...",
    "or": "ou",
    "forgotPassword": "Mot de passe oublié ?",
    "continueWithGoogle": "Continuer avec Google",
    "noAccount": "Pas de compte ?",
    "signUp": "S'inscrire",
    "register": "S'inscrire",
    "name": "Nom",
    "termsNotice": "En vous connectant, vous acceptez nos Conditions d'utilisation et notre Politique de confidentialité",
    "errors": {
      "emailRequired": "L'e-mail est requis",
      "passwordRequired": "Le mot de passe est requis",
      "loginFailed": "Échec de la connexion. Veuillez vérifier vos identifiants.",
      "googleFailed": "Échec de la connexion Google. Veuillez réessayer.",
      "fillAllFields": "Veuillez remplir tous les champs"
    },
    "qrInstructions": "Scannez le code avec votre téléphone pour une connexion rapide",
    "methodQR": "Code QR",
    "methodVoice": "Voix",
    "methodTraditional": "E-mail",
    "qrTitle": "Scanner pour se connecter",
    "qrDescription": "Scannez ce code QR avec votre téléphone pour vous connecter sans taper",
    "expiresIn": "Expire dans 5 minutes",
    "companionConnected": "Téléphone connecté !",
    "authenticating": "Connexion en cours...",
    "sessionExpired": "Session expirée",
    "refreshQR": "Générer un nouveau code",
    "generatingQR": "Génération du code QR...",
    "howItWorks": "Comment ça marche :",
    "step1": "Ouvrez l'appareil photo de votre téléphone",
    "step2": "Scannez le code QR ci-dessus",
    "step3": "Connectez-vous sur votre téléphone",
    "step4": "La TV se connecte automatiquement !",
    "voicePlaceholder": "Tapez votre réponse...",
    "send": "Envoyer",
    "createAccount": "Créer un compte",
    "bayitThinking": "Bayit réfléchit...",
    "unexpectedError": "Une erreur inattendue s'est produite"
  },
  "tvLogin": {
    "invalidQR": "Code QR invalide. Veuillez scanner à nouveau depuis votre TV.",
    "sessionInvalid": "Ce code QR a expiré. Veuillez en générer un nouveau sur votre TV.",
    "verificationFailed": "Échec de la vérification de la session. Veuillez réessayer.",
    "fillAllFields": "Veuillez remplir tous les champs",
    "loginFailed": "Échec de la connexion. Veuillez vérifier vos identifiants.",
    "notLoggedIn": "Vous n'êtes pas connecté sur cet appareil.",
    "enterCredentials": "Veuillez entrer vos identifiants pour autoriser votre TV.",
    "authFailed": "Échec de l'autorisation.",
    "verifying": "Vérification...",
    "verifyingDescription": "Connexion à votre TV...",
    "loginTitle": "Connexion à votre TV",
    "loginDescription": "Entrez vos identifiants pour autoriser votre TV",
    "authorizing": "Autorisation...",
    "authorizingDescription": "Connexion sur votre TV...",
    "authorizeTV": "Autoriser la TV",
    "success": "Succès !",
    "successDescription": "Votre TV est maintenant connectée. Vous pouvez fermer cette page.",
    "goToHome": "Aller à l'accueil",
    "error": "Quelque chose s'est mal passé",
    "tryAgain": "Réessayer",
    "securityNote": "Vos identifiants sont envoyés de manière sécurisée et ne sont jamais stockés sur la TV.",
    "footer": "Des problèmes ? Assurez-vous d'avoir scanné un code QR récent depuis votre TV.",
    "almostThere": "Presque la !",
    "authenticating": "Authentification...",
    "connected": "Connecte",
    "expired": "Code expire",
    "expiredMessage": "Votre code a expire. Veuillez en demander un nouveau.",
    "header": "Se connecter a la TV",
    "pleaseSignIn": "Connectez-vous sur votre telephone ou ordinateur",
    "signInButton": "Se connecter",
    "signInToTV": "Se connecter a la TV",
    "subtitle": "Entrez le code affiche sur votre TV",
    "tvSignedIn": "TV connectee avec succes"
  },
  "googleLogin": {
    "cancelledError": "Connexion Google annulée",
    "missingCode": "Le code d'authentification est manquant",
    "loginError": "Erreur lors de la connexion avec Google",
    "redirecting": "Redirection vers la page de connexion...",
    "connecting": "Connexion avec Google..."
  },
  "register": {
    "title": "Créer un compte",
    "subtitle": "Rejoignez Bayit+ pour regarder vos contenus préférés",
    "name": "Nom complet",
    "namePlaceholder": "Jean Dupont",
    "email": "E-mail",
    "emailPlaceholder": "votre@email.com",
    "password": "Mot de passe",
    "passwordPlaceholder": "Au moins 8 caractères",
    "confirmPassword": "Confirmer le mot de passe",
    "confirmPasswordPlaceholder": "Entrez à nouveau le mot de passe",
    "submit": "S'inscrire",
    "registering": "Inscription en cours...",
    "acceptTerms": "J'accepte les",
    "termsOfService": "Conditions d'utilisation",
    "and": "et la",
    "privacyPolicy": "Politique de confidentialité",
    "continueWithGoogle": "S'inscrire avec Google",
    "haveAccount": "Déjà un compte ?",
    "signIn": "Se connecter",
    "fullName": "Nom complet",
    "loginLink": "Connexion",
    "placeholders": {
      "fullName": "Jean Dupont",
      "email": "votre@email.com",
      "password": "Au moins 8 caractères",
      "confirmPassword": "Entrez à nouveau le mot de passe"
    },
    "errors": {
      "nameRequired": "Le nom est requis",
      "emailRequired": "L'e-mail est requis",
      "passwordRequired": "Le mot de passe est requis",
      "passwordTooShort": "Le mot de passe doit contenir au moins 8 caractères",
      "passwordMismatch": "Les mots de passe ne correspondent pas",
      "acceptTerms": "Vous devez accepter les Conditions d'utilisation et la Politique de confidentialité",
      "fillAllFields": "Veuillez remplir tous les champs",
      "registrationFailed": "Échec de l'inscription. Veuillez réessayer.",
      "googleFailed": "Échec de l'inscription avec Google. Veuillez réessayer."
    }
  },
  "nav": {
    "home": "Accueil",
    "vod": "VOD",
    "liveTV": "TV en direct",
    "epg": "Guide TV",
    "radio": "Radio",
    "podcasts": "Podcasts",
    "flows": "Flux",
    "judaism": "Judaïsme",
    "children": "Enfants",
    "profile": "Profil",
    "search": "Rechercher",
    "settings": "Paramètres",
    "favorites": "Favoris",
    "watchlist": "Liste de lecture",
    "downloads": "Téléchargements",
    "recordings": "Mes enregistrements",
    "widgets": "Widgets",
    "help": "Aide et support",
    "discover": "Découvrir",
    "account": "Compte",
    "subscribe": "S'abonner",
    "plans": "Forfaits",
    "admin": "Administrateur",
    "games": "Jeux",
    "friends": "Amis",
    "glossary": "Glossaire",
    "missions": "Missions",
    "audiobooks": "Livres audio",
    "playlist": "Liste de lecture",
    "zehAniHub": "Zeh Ani",
    "support": "Support",
    "discoverHub": "Decouvrir IA",
    "listen": "Ecouter",
    "byoc": "Mes sources",
    "household": "Foyer",
    "messages": "Messages",
    "myContent": "Mon contenu",
    "social": "Social"
  },
  "epg": {
    "title": "Guide TV",
    "subtitle": "Parcourez le programme de la télévision en direct",
    "gridView": "Vue grille",
    "listView": "Vue liste",
    "israelTime": "Heure d'Israël",
    "localTime": "Heure locale",
    "il": "IL",
    "local": "Local",
    "jumpToNow": "Aller à maintenant",
    "goBack": "← {{hours}}h",
    "goForward": "{{hours}}h →",
    "toggleTimezone": "Changer de fuseau horaire",
    "errorTitle": "Échec du chargement du guide TV",
    "errorLoading": "Impossible de charger les données du guide TV",
    "noPrograms": "Aucun programme trouvé",
    "noChannels": "Aucune chaîne disponible",
    "recordProgram": "Enregistrer le programme",
    "channel": "Chaîne",
    "enableSubtitles": "Activer les sous-titres",
    "subtitleLanguage": "Langue des sous-titres",
    "storageEstimate": "Estimation du stockage",
    "availableSpace": "Espace disponible",
    "lowStorage": "Avertissement stockage faible",
    "lowStorageMessage": "Votre espace de stockage est faible. Pensez à supprimer d'anciens enregistrements.",
    "scheduleRecording": "Programmer l'enregistrement",
    "scheduledRecordingNotSupported": "Les enregistrements programmés ne sont pas encore pris en charge. Seuls les enregistrements immédiats sont disponibles.",
    "recordingFailed": "Échec du démarrage/programmation de l'enregistrement",
    "smartSearch": "Recherche intelligente",
    "smartSearchSubtitle": "Posez des questions en langage naturel",
    "smartSearchPlaceholder": "ex: Montrez-moi tous les programmes avec l'actrice Tali Sharon ce soir",
    "searchPlaceholder": "Rechercher des programmes, chaînes, acteurs...",
    "premiumRequired": "Fonctionnalité Premium",
    "premiumRequiredMessage": "La recherche intelligente utilise l'IA pour comprendre vos questions. Passez à Premium pour accéder à cette fonctionnalité.",
    "searchWithAI": "Rechercher avec l'IA",
    "searching": "Recherche en cours...",
    "tryThese": "Essayez ces exemples",
    "exampleQuery1": "Montrez-moi tous les programmes avec l'actrice Tali Sharon ce soir",
    "exampleQuery2": "Quelles émissions comiques sont diffusées cette semaine ?",
    "exampleQuery3": "Trouver des documentaires sur l'histoire sur la chaîne 11",
    "exampleQuery4": "Montrez-moi tous les programmes d'information demain matin",
    "aiDisclaimer": "Propulsé par Claude AI. Les résultats peuvent varier selon la disponibilité des données.",
    "interpretationTitle": "Ce que j'ai compris",
    "noResultsFound": "Aucun programme correspondant à votre recherche"
  },
  "home": {
    "continueWatching": "Continuer à regarder",
    "featuredContent": "À la une",
    "liveTV": "TV en direct",
    "allChannels": "Toutes les chaînes",
    "liveChannels": "Chaînes en direct",
    "showOnlyWithSubtitles": "Afficher uniquement avec sous-titres",
    "israeliMovies": "Films israéliens",
    "israeli-movies": "Films israéliens",
    "israeli-series": "Séries israéliennes",
    "action": "Action et Thriller",
    "comedy": "Comédie",
    "drama": "Drame",
    "documentaries": "Documentaires",
    "loadingContent": "Chargement du contenu...",
    "liveNow": "En direct maintenant",
    "trendingInIsrael": "Tendances en Israël",
    "jerusalemConnection": "Connexion Jérusalem",
    "telAvivConnection": "Connexion Tel Aviv",
    "categories": "Catégories",
    "nearYou": "Israéliens Près de Vous",
    "betaExclusive": "Exclusif Bêta",
    "carousel": {
      "fauda": {
        "title": "Fauda",
        "subtitle": "Saison 4 - En streaming",
        "description": "La série israélienne à succès revient pour une quatrième saison pleine de suspense et d'action"
      },
      "shtisel": {
        "title": "Shtisel",
        "subtitle": "Toutes les saisons disponibles",
        "description": "Suivez la famille Shtisel dans le quartier ultra-orthodoxe de Jérusalem"
      },
      "tehran": {
        "title": "Téhéran",
        "subtitle": "Saison 2",
        "description": "Un agent du Mossad en mission dangereuse en Iran"
      },
      "live": {
        "title": "En direct - Kan 11",
        "subtitle": "Regardez maintenant",
        "description": "Actualités, affaires courantes et contenu de qualité"
      }
    },
    "enableLocation": "Activer la localisation",
    "locationPermissionDeniedDescription": "L'acces a la localisation a ete refuse. Activez-le dans les Parametres.",
    "locationPermissionDescription": "Autorisez l'acces a la localisation pour decouvrir du contenu pres de vous.",
    "openSettings": "Ouvrir les parametres"
  },
  "search": {
    "title": "Rechercher",
    "subtitle": "Trouvez des films, séries, chaînes, radios et podcasts",
    "placeholder": "Rechercher du contenu...",
    "voicePlaceholder": "Parlez maintenant...",
    "searching": "Recherche en cours...",
    "listening": "Écoute...",
    "noResults": "Aucun résultat trouvé",
    "noResultsHint": "Essayez différents mots-clés ou modifiez vos filtres",
    "tryDifferent": "Essayez d'autres termes de recherche",
    "resultsFor": "résultats pour",
    "resultsFound": "{{count}} résultats trouvés pour \"{{query}}\"",
    "recentSearches": "Recherches récentes",
    "clearAll": "Tout effacer",
    "trending": "Recherches tendances",
    "promptTitle": "Que cherchez-vous ?",
    "promptDescription": "Recherchez votre contenu préféré ou utilisez la recherche vocale",
    "filters": {
      "all": "Tout",
      "vod": "Films et Séries",
      "live": "Chaînes",
      "radio": "Radio",
      "podcast": "Podcasts",
      "moviesAndSeries": "Films et Séries",
      "channels": "Chaînes",
      "podcasts": "Podcasts"
    },
    "suggestions": {
      "movies": "Films",
      "series": "Séries",
      "liveTV": "TV en direct",
      "news": "Actualités",
      "sports": "Sports",
      "kids": "Enfants"
    }
  },
  "liveTV": {
    "title": "TV en direct",
    "channels": "Chaînes",
    "nowPlaying": "En cours",
    "loadError": "Échec du chargement des chaînes",
    "categories": {
      "all": "Tout",
      "news": "Actualités",
      "sports": "Sports",
      "entertainment": "Divertissement",
      "kids": "Enfants",
      "documentary": "Documentaire"
    }
  },
  "listen": {
    "title": "Écouter",
    "subtitle": "Radio, Podcasts et Livres audio",
    "tab": {
      "radio": "Radio",
      "podcasts": "Podcasts",
      "audiobooks": "Livres audio"
    }
  },
  "radio": {
    "title": "Radio",
    "categories": {
      "all": "Tout",
      "music": "Musique",
      "news": "Actualités",
      "talk": "Parler",
      "jewish": "Juif"
    },
    "noStations": "Aucune station de radio disponible",
    "tryLater": "Réessayez plus tard",
    "playing": "EN LECTURE",
    "fmSuffix": "FM"
  },
  "podcasts": {
    "title": "Podcasts",
    "episodes": "épisodes",
    "categories": {
      "all": "Tout",
      "general": "Général",
      "news": "Actualités",
      "politics": "Politique",
      "tech": "Tech",
      "business": "Entreprise",
      "jewish": "Juif",
      "entertainment": "Divertissement",
      "sports": "Sports",
      "history": "Histoire",
      "educational": "Éducatif"
    },
    "noPodcasts": "Aucun podcast disponible",
    "tryLater": "Réessayez plus tard",
    "playLatest": "Lire le dernier"
  },
  "vod": {
    "title": "Films et Séries",
    "movies": "Films",
    "series": "Séries",
    "searchPlaceholder": "Rechercher des films et séries...",
    "noMovies": "Aucun film trouvé",
    "noSeries": "Aucune série trouvée",
    "loadError": "Échec du chargement du contenu",
    "showOnlyWithSubtitles": "Afficher uniquement avec sous-titres",
    "categories": {
      "all": "Tout",
      "drama": "Drame",
      "comedy": "Comédie",
      "action": "Action",
      "documentary": "Documentaire",
      "kids": "Enfants"
    },
    "allCategories": "Tout",
    "emptyTitle": "Aucun contenu disponible",
    "emptyDescription": "Essayez de sélectionner une autre catégorie",
    "allContent": "Tout le contenu",
    "noContent": "Aucun contenu disponible",
    "noContentInCategory": "Aucun contenu trouvé dans cette catégorie"
  },
  "account": {
    "title": "Mon compte",
    "profile": "Profil",
    "settings": "Paramètres",
    "subscription": "Abonnement",
    "manageSubscription": "Gérer l'abonnement",
    "personalDetails": "Détails personnels",
    "billing": "Facturation et paiement",
    "logout": "Déconnexion",
    "login": "Connexion",
    "register": "Inscription",
    "email": "E-mail",
    "password": "Mot de passe",
    "name": "Nom",
    "guest": "Invité",
    "premium": "Premium",
    "basic": "Basique"
  },
  "flows": {
    "title": "Flux",
    "subtitle": "Des expériences de contenu personnalisées pour chaque moment",
    "activeNow": "En ligne maintenant",
    "start": "Démarrer",
    "skipToday": "Passer aujourd'hui",
    "systemFlows": "Flux prêts à l'emploi",
    "customFlows": "Mes flux",
    "system": "Système",
    "noCustomFlows": "Pas encore de flux personnalisés",
    "createHint": "Créez votre premier flux personnalisé",
    "createCustom": "Créer un flux personnalisé",
    "createFlow": "Créer un flux",
    "editFlow": "Modifier le flux",
    "type": "Type",
    "systemFlow": "Flux système",
    "customFlow": "Flux personnalisé",
    "schedule": "Programme",
    "content": "Contenu",
    "items": "éléments",
    "aiGenerated": "Généré par l'IA",
    "autoPlay": "Lecture automatique",
    "aiEnabled": "Curation IA",
    "shabbatTrigger": "Soirée de Chabbat",
    "manual": "Manuel",
    "flowName": "Nom du flux",
    "flowNamePlaceholder": "ex. Ma routine matinale",
    "description": "Description",
    "descriptionPlaceholder": "À quoi sert ce flux ?",
    "startTime": "Heure de début",
    "endTime": "Heure de fin",
    "actions": "Actions",
    "details": "Détails",
    "createFlowDesc": "Concevez votre expérience de contenu personnalisée",
    "editFlowDesc": "Mettez à jour les paramètres et le contenu de votre flux",
    "basicInfo": "Informations de base",
    "options": "Options",
    "autoPlayDesc": "Lire automatiquement l'élément suivant à la fin du précédent",
    "aiEnabledDesc": "Laissez l'IA sélectionner du contenu selon vos préférences",
    "startFlow": "Démarrer le flux",
    "deleteFlow": "Supprimer le flux",
    "custom": "Personnalisé",
    "morning": "Matin",
    "evening": "Soirée",
    "shabbat": "Chabbat",
    "addContent": "Ajouter du contenu",
    "contentPicker": {
      "title": "Ajouter du contenu au flux",
      "tabs": {
        "live": "TV en direct",
        "radio": "Radio",
        "vod": "À la demande",
        "podcast": "Podcasts"
      },
      "search": "Rechercher du contenu...",
      "selected": "{{count}} sélectionnés",
      "addSelected": "Ajouter la sélection",
      "noResults": "Aucun contenu trouvé",
      "alreadyAdded": "Déjà dans le flux",
      "loadMore": "Charger plus"
    },
    "flowItems": {
      "title": "Contenu du flux",
      "empty": "Pas encore de contenu. Cliquez sur Ajouter du contenu pour commencer.",
      "count": "{{count}} éléments",
      "remove": "Supprimer",
      "moveUp": "Déplacer vers le haut",
      "moveDown": "Déplacer vers le bas",
      "order": "Ordre",
      "confirmRemove": "Cliquez à nouveau pour confirmer la suppression",
      "maxReached": "Maximum de {{max}} éléments atteint",
      "more": "plus d'éléments"
    },
    "days": {
      "sunday": "Dimanche",
      "monday": "Lundi",
      "tuesday": "Mardi",
      "wednesday": "Mercredi",
      "thursday": "Jeudi",
      "friday": "Vendredi",
      "saturday": "Samedi",
      "sundayShort": "Sun",
      "mondayShort": "Mon",
      "tuesdayShort": "Tue",
      "wednesdayShort": "Wed",
      "thursdayShort": "Thu",
      "fridayShort": "Fri",
      "saturdayShort": "Sat",
      "selectAll": "Tout sélectionner",
      "deselectAll": "Tout désélectionner",
      "title": "Jours actifs",
      "everyday": "Tous les jours",
      "everyDay": "Tous les jours",
      "weekdays": "Jours de semaine",
      "weekends": "Week-ends",
      "noneSelected": "Aucun jour sélectionné",
      "selectedCount": "{{count}} jours sélectionnés"
    },
    "trigger": {
      "type": "Type de déclencheur",
      "time": "Basé sur l'heure",
      "shabbat": "Soirée de Chabbat",
      "holiday": "Fête",
      "skipShabbat": "Passer le Chabbat",
      "skipShabbatDesc": "Ne pas exécuter ce flux le vendredi soir ou le samedi",
      "shabbatOffset": "Minutes avant l'allumage des bougies",
      "shabbatOffsetDesc": "Combien de minutes avant le Chabbat ce flux doit-il démarrer ?",
      "calculatedTime": "Heure calculée",
      "thisWeek": "Cette semaine : {{day}} à {{time}}",
      "comingSoon": "Déclencheurs de fêtes bientôt disponibles",
      "locationBased": "Horaires basés sur votre emplacement"
    },
    "examples": {
      "title": "Exemples de flux",
      "subtitle": "Appuyez pour utiliser comme modèle",
      "morningRoutine": {
        "name": "Routine matinale",
        "desc": "Commencez votre journée avec les nouvelles, la météo et du contenu inspirant"
      },
      "eveningWindDown": {
        "name": "Détente du soir",
        "desc": "Détendez-vous avec de la musique apaisante et du divertissement léger"
      },
      "shabbatPrep": {
        "name": "Préparation du Chabbat",
        "desc": "Créez l'ambiance du Chabbat avec un contenu spécial"
      },
      "coffeeBreak": {
        "name": "Pause café",
        "desc": "Divertissement rapide pour une courte pause"
      },
      "sunsetVibes": {
        "name": "Ambiance coucher de soleil",
        "desc": "Détente du week-end avec musique et contenu ambiant"
      }
    },
    "aiBrief": "Résumé IA",
    "aiBriefDesc": "Obtenez un résumé personnalisé généré par l'IA avant le début du flux",
    "aiBriefEnabled": "Résumé IA activé",
    "validation": {
      "nameRequired": "Le nom du flux est requis",
      "startTimeRequired": "L'heure de début est requise",
      "endTimeRequired": "L'heure de fin est requise",
      "timeRange": "L'heure de fin doit être après l'heure de début",
      "daysRequired": "Sélectionnez au moins un jour",
      "contentRequired": "Ajouter du contenu ou activer l'IA"
    },
    "tv": {
      "useCompanion": "Pour une personnalisation complète, utilisez l'application Bayit+ sur votre téléphone ou visitez bayit.plus sur votre ordinateur."
    }
  },
  "profile": {
    "title": "Mon profil",
    "profileDetails": "Détails du profil",
    "name": "Nom",
    "notSet": "Non défini",
    "email": "E-mail",
    "editProfile": "Modifier le profil",
    "notificationSettings": "Paramètres de notification",
    "security": "Sécurité",
    "changePassword": "Changer le mot de passe",
    "updatePassword": "Mettre à jour votre mot de passe",
    "connectedDevices": "Appareils connectés",
    "manageDevices": "Gérer les appareils connectés à votre compte",
    "twoFactorAuth": "Authentification à deux facteurs",
    "addExtraSecurity": "Ajoutez une couche de sécurité supplémentaire",
    "address": {
      "line1": "123 rue Principale",
      "line2": "Tel-Aviv, Israël 6100000"
    },
    "free": "Gratuit",
    "premiumPrice": "7,99 $/mois",
    "familyPrice": "12,99 $/mois",
    "remaining": "restant",
    "tabs": {
      "personal": "Personnel",
      "overview": "Aperçu",
      "subscription": "Abonnement",
      "notifications": "Notifications",
      "security": "Sécurité",
      "ai": "IA et voix",
      "voice": "Voix et accessibilité"
    },
    "subscription": {
      "currentPlan": "Forfait actuel",
      "renewsOn": "Renouvellement le",
      "manageSubscription": "Gérer l'abonnement",
      "cancelSubscription": "Annuler l'abonnement",
      "noActivePlan": "Aucun abonnement actif",
      "selectPlan": "Sélectionner un forfait"
    },
    "notifications": "Notifications",
    "ai": {
      "title": "IA et personnalisation",
      "description": "Configurer les fonctionnalités IA",
      "assistant": "Assistant IA",
      "assistantDesc": "Recommandations personnalisées et aide",
      "chatbot": "Assistant IA",
      "chatbotEnabled": "Activer l'assistant IA",
      "chatbotEnabledDesc": "Obtenez de l'aide pour naviguer dans le contenu",
      "saveHistory": "Sauvegarder l'historique des conversations",
      "saveHistoryDesc": "Se souvenir des conversations précédentes",
      "recommendations": "Recommandations",
      "personalizedRecs": "Recommandations personnalisées",
      "personalizedRecsDesc": "Suggestions de contenu basées sur l'historique",
      "privacy": "Confidentialité et données",
      "privacyDesc": "Vos données sont chiffrées et sécurisées",
      "dataConsent": "Analyse d'utilisation",
      "dataConsentDesc": "Aidez à améliorer les fonctionnalités IA",
      "privacyNote": "Vos données sont chiffrées et sécurisées"
    },
    "voice": {
      "title": "Contrôle vocal",
      "description": "Navigation mains libres",
      "enabled": "Commandes vocales",
      "enabledDesc": "Contrôlez l'application avec votre voix",
      "tts": "Synthèse vocale",
      "ttsDesc": "Réponses IA lues à voix haute",
      "wakeWord": "Détection du mot d'activation",
      "wakeWordDesc": "Dites « Bayit » pour activer",
      "operationMode": "Mode de fonctionnement",
      "operationModeDesc": "Choisissez comment interagir avec l'application",
      "voiceSearch": "Recherche vocale",
      "voiceSearchEnabled": "Activer la recherche vocale",
      "voiceSearchEnabledDesc": "Recherchez du contenu avec votre voix",
      "constantListening": "Mode d'écoute permanente",
      "constantListeningDesc": "Écouter en continu les commandes vocales sans appuyer sur un bouton",
      "constantListeningPrivacy": "L'audio n'est envoyé aux serveurs que lorsque la parole est détectée",
      "holdButtonMode": "Maintenir le bouton pour parler",
      "holdButtonModeDesc": "Maintenez le bouton du microphone au lieu de l'écoute permanente",
      "sensitivity": "Sensibilité de détection vocale",
      "sensitivityDesc": "Ajustez la sensibilité de la détection vocale",
      "sensitivityLow": "Faible (moins de faux déclenchements)",
      "sensitivityMedium": "Moyenne (équilibrée)",
      "sensitivityHigh": "Élevée (la plus réactive)",
      "silenceThreshold": "Détection du silence",
      "silenceThresholdDesc": "Combien de temps attendre après avoir parlé avant le traitement",
      "language": "Langue vocale",
      "accessibility": "Accessibilité",
      "autoSubtitle": "Activer automatiquement les sous-titres",
      "autoSubtitleDesc": "Afficher automatiquement les sous-titres lors de la lecture",
      "highContrast": "Mode contraste élevé",
      "highContrastDesc": "Augmenter le contraste pour une meilleure visibilité",
      "textSize": "Taille du texte",
      "textSizeSmall": "Petit",
      "textSizeMedium": "Moyen",
      "textSizeLarge": "Grand",
      "voiceOnlyInfo": "Mode voix uniquement",
      "voiceOnlyDetails": "Dites « Hi Bayit » pour activer. Télécommande désactivée. Naviguez entièrement avec les commandes vocales.",
      "hybridInfo": "Mode hybride",
      "hybridDetails": "Utilisez la voix ou la télécommande. Retour vocal sur les actions non vocales.",
      "classicInfo": "Mode classique",
      "classicDetails": "Toutes les fonctions vocales désactivées. Télécommande uniquement.",
      "textToSpeech": "Réponses vocales",
      "ttsEnabled": "Activer les réponses vocales",
      "ttsEnabledDesc": "L'application prononcera les réponses à vos commandes vocales",
      "ttsVolume": "Volume de la voix",
      "ttsSpeed": "Vitesse de parole",
      "hybridFeedback": "Retour interactif",
      "voiceFeedback": "Retour vocal sur les actions",
      "voiceFeedbackDesc": "Recevez une confirmation vocale lorsque vous utilisez la télécommande ou cliquez sur les boutons",
      "feedbackExample": "Exemple : Cliquez sur un film → L'application dit « Lecture de [Nom du film] »"
    },
    "dropdown": {
      "myProfile": "Mon profil",
      "subscription": "Abonnement",
      "favorites": "Favoris",
      "downloads": "Téléchargements",
      "signOut": "Se déconnecter"
    },
    "guest": "Invité",
    "morningRitual": "Rituel du matin",
    "watchlist": "Liste de visionnage",
    "favorites": "Favoris",
    "downloads": "Téléchargements",
    "settings": "Paramètres",
    "language": "Langue",
    "admin": "Administrateur",
    "watchTime": "Temps de visionnage",
    "minutes": "minutes",
    "hours": "heures",
    "logout": "Se déconnecter",
    "premium": "Premium",
    "basic": "Basique",
    "upgrade": "Passer au Premium",
    "memberSince": "Membre depuis",
    "aiAssistant": "Assistant IA",
    "voiceSettings": "Voix",
    "subscriptionButton": "Abonnement",
    "recentActivity": "Activité récente",
    "justNow": "À l'instant",
    "hoursAgo": "il y a {{hours}} heures",
    "yesterday": "Hier",
    "noRecentActivity": "Aucune activité récente",
    "accountInfo": "Informations du compte",
    "role": "Rôle",
    "accountSecurity": "Sécurité du compte",
    "securityNote": "Votre compte est sécurisé avec une authentification chiffrée",
    "lastLogin": "Dernière connexion",
    "dangerZone": "Zone dangereuse",
    "invalidImageType": "Veuillez sélectionner un fichier image valide (JPEG, PNG, WebP ou GIF)",
    "imageTooLarge": "L'image est trop grande. La taille maximale est de 5 Mo.",
    "uploadSuccess": "Avatar mis à jour avec succès !",
    "uploadFailed": "Échec du téléchargement de l'avatar. Veuillez réessayer.",
    "complimentaryPremium": "ACCÈS PREMIUM GRATUIT",
    "emailVerified": "Email vérifié",
    "emailUnverified": "Email non vérifié",
    "phoneVerified": "Téléphone vérifié",
    "phoneUnverified": "Téléphone non vérifié",
    "completeVerification": "Complétez la vérification pour débloquer toutes les fonctionnalités",
    "unlockPremium": "Débloquer les Fonctionnalités Premium",
    "unlockPremiumDescription": "Passez à la version supérieure pour profiter du contenu et des fonctionnalités exclusives"
  },
  "voiceMode": {
    "voiceOnly": "Voix uniquement",
    "voiceOnlyDesc": "Pas de télécommande - navigation vocale complète",
    "hybrid": "Hybride",
    "hybridDesc": "Voix + télécommande - retour vocal sur les actions",
    "classic": "Classique",
    "classicDesc": "Pas de voix - télécommande uniquement"
  },
  "settings": {
    "title": "Paramètres",
    "language": "Langue",
    "appLanguage": "Langue de l'application",
    "selectLanguage": "Sélectionner la langue",
    "languages": {
      "en": "Anglais",
      "he": "Hébreu",
      "es": "Espagnol",
      "zh": "中文",
      "fr": "Français",
      "it": "Italien",
      "hi": "Hindi",
      "ta": "Tamoul",
      "bn": "Bengali",
      "ja": "日本語"
    },
    "chatTranslation": "Traduction du chat",
    "autoTranslate": "Traduire automatiquement les messages",
    "autoTranslateDescription": "Traduire automatiquement les messages du chat dans votre langue préférée",
    "notifications": "Notifications",
    "pushNotifications": "Notifications push",
    "playback": "Lecture",
    "quality": "Qualité",
    "subtitles": "Sous-titres",
    "autoplay": "Lecture automatique",
    "appearance": "Apparence",
    "darkMode": "Mode sombre",
    "privacy": "Confidentialité",
    "privacyPolicy": "Politique de confidentialité",
    "termsOfService": "Conditions d'utilisation",
    "about": "À propos",
    "display": "Affichage",
    "homePageSections": "Sections de la page d'accueil",
    "configureSections": "Configurez les sections qui apparaissent sur votre page d'accueil",
    "visibleSections": "Sections visibles",
    "hiddenSections": "Sections masquées",
    "dragToReorder": "Faites glisser pour réorganiser",
    "tapToHide": "Appuyez pour masquer",
    "tapToShow": "Appuyez pour afficher",
    "resetToDefault": "Réinitialiser par défaut",
    "resetConfirmMessage": "Êtes-vous sûr de vouloir réinitialiser les sections de la page d'accueil ?",
    "sectionHidden": "Section masquée",
    "sectionShown": "Section affichée",
    "replayTour": "Revoir la visite des fonctionnalités"
  },
  "help": {
    "subtitle": "Comment pouvons-nous vous aider ?",
    "email": "Assistance par e-mail",
    "phone": "Assistance téléphonique",
    "chat": "Chat en direct",
    "chatAvailable": "Disponible 24h/24",
    "openTooltip": "Ouvrir l'infobulle d'aide",
    "openHelp": "Ouvrir le menu d'aide",
    "howTo": "Comment utiliser",
    "relatedArticles": "Articles associés",
    "stillNeedHelp": "Besoin d'aide supplémentaire ?",
    "contactSupport": "Contacter le support",
    "previous": "Précédent",
    "next": "Suivant",
    "getStarted": "Commencer",
    "skipTutorial": "Passer le tutoriel",
    "actions": {
      "search": "Aide à la recherche",
      "docs": "Documentation",
      "faq": "FAQ",
      "support": "Contacter le support",
      "tutorial": "Voir le tutoriel"
    },
    "search": {
      "placeholder": "Rechercher de l'aide...",
      "noResults": "Aucun résultat trouvé pour « {{query}} »",
      "noResultsHint": "Essayez d'autres mots-clés ou parcourez les catégories",
      "recent": "Récent",
      "popular": "Populaire"
    },
    "categories": {
      "getting-started": "Pour commencer",
      "features": "Fonctionnalités",
      "judaism": "Judaïsme",
      "platform-guides": "Guides de la plateforme",
      "account": "Compte",
      "troubleshooting": "Dépannage",
      "parents": "Pour les parents",
      "admin": "Guide d'administration",
      "developer": "API développeur"
    },
    "faq": {
      "title": "Questions fréquemment posées",
      "q1": "Comment changer mon forfait d'abonnement ?",
      "a1": "Allez dans Paramètres > Abonnement pour consulter et modifier votre forfait actuel. Vous pouvez mettre à niveau ou rétrograder à tout moment.",
      "q2": "Comment télécharger du contenu pour le visionnage hors ligne ?",
      "a2": "Appuyez sur l'icône de téléchargement sur n'importe quel contenu pour le sauvegarder pour le visionnage hors ligne. Les téléchargements sont disponibles uniquement sur les appareils mobiles.",
      "q3": "Pourquoi ma vidéo ne se lance-t-elle pas ?",
      "a3": "Vérifiez votre connexion Internet. Si le problème persiste, essayez de vider le cache de l'application ou de la redémarrer.",
      "q4": "Comment annuler mon abonnement ?",
      "a4": "Vous pouvez annuler votre abonnement à tout moment via Paramètres > Abonnement > Annuler le forfait. Vous continuerez à avoir accès jusqu'à la fin de votre période de facturation."
    },
    "onboarding": {
      "welcome": {
        "title": "Bienvenue sur Bayit+",
        "description": "Votre foyer de divertissement israélien, partout dans le monde"
      },
      "liveTv": {
        "title": "TV en direct",
        "description": "Regardez les chaînes israéliennes en direct, y compris l'actualité, le sport et le divertissement"
      },
      "vod": {
        "title": "Contenu à la demande",
        "description": "Parcourez films, séries et documentaires à tout moment"
      },
      "voice": {
        "title": "Contrôle vocal",
        "description": "Dites « Bayit » pour contrôler l'application avec votre voix"
      },
      "profiles": {
        "title": "Profils familiaux",
        "description": "Créez des profils pour chaque membre de la famille avec des recommandations personnalisées"
      }
    }
  },
  "voice": {
    "panelTitle": "Assistant vocal",
    "typeCommand": "Saisissez une commande...",
    "controlExecuted": "Exécuté : {{action}}",
    "timerSet": "Minuteur défini pour {{amount}} {{unit}}",
    "chatPending": "Traitement de votre message...",
    "suggestion": {
      "watchLive": "Regarder la TV en direct",
      "search": "Rechercher du contenu",
      "listenRadio": "Écouter la radio"
    },
    "error": {
      "micDenied": "Accès au microphone refusé",
      "notSupported": "Les commandes vocales ne sont pas prises en charge dans ce navigateur",
      "recognitionFailed": "Impossible de comprendre. Veuillez réessayer."
    }
  },
  "errors": {
    "networkError": "Erreur réseau",
    "loadingFailed": "Échec du chargement",
    "tryAgain": "Réessayer",
    "offline": {
      "title": "Pas de connexion Internet",
      "message": "Vous êtes actuellement hors ligne. Certaines fonctionnalités peuvent ne pas être disponibles.",
      "ttsMessage": "Pas de connexion Internet. Vous êtes maintenant en mode hors ligne."
    },
    "online": {
      "title": "Connexion rétablie",
      "message": "Vous êtes de nouveau en ligne.",
      "ttsMessage": "Connexion Internet rétablie."
    },
    "api": {
      "badRequest": "Un problème est survenu. Veuillez réessayer.",
      "unauthorized": "Veuillez vous connecter pour continuer.",
      "forbidden": "Vous n'avez pas la permission d'accéder à ce contenu.",
      "notFound": "Le contenu que vous recherchez n'est pas disponible.",
      "rateLimit": "Vous faites trop de requêtes. Veuillez patienter.",
      "serverError": "Nos serveurs rencontrent des problèmes. Veuillez réessayer plus tard.",
      "unknown": "Un problème est survenu. Veuillez réessayer.",
      "networkTimeout": "Impossible de se connecter à nos serveurs. Veuillez vérifier votre connexion.",
      "offlineMessage": "Vous êtes hors ligne. Veuillez vérifier votre connexion Internet.",
      "requestFailed": "Un problème est survenu. Veuillez réessayer."
    },
    "voice": {
      "permissionDenied": "L'accès au microphone est requis pour les commandes vocales. Veuillez l'activer dans les paramètres.",
      "recognitionFailed": "Je n'ai pas compris. Veuillez réessayer.",
      "commandFailed": "Commande vocale échouée. Veuillez réessayer."
    },
    "widget": {
      "loadFailed": "Impossible de charger le widget. Veuillez réessayer."
    },
    "buttons": {
      "ok": "OK",
      "retry": "Réessayer",
      "cancel": "Annuler"
    },
    "title": "Erreur",
    "networkUnavailable": "Réseau non disponible",
    "no_audio_url": "URL audio non disponible",
    "connection_failed": "Échec de Connexion",
    "quota_exceeded": "Quota Dépassé",
    "server_error": "Erreur Serveur"
  },
  "player": {
    "loading": "Chargement...",
    "retry": "Réessayer",
    "error": "Erreur de lecture vidéo",
    "back": "← Retour",
    "liveBadge": "EN DIRECT",
    "noStream": "Flux non disponible",
    "loadError": "Échec du chargement du flux",
    "settings": "Paramètres",
    "subtitles": "Sous-titres",
    "playbackSpeed": "Vitesse de lecture",
    "quality": "Qualité",
    "auto": "Automatique",
    "previousChapter": "Chapitre précédent",
    "nextChapter": "Chapitre suivant",
    "skipBackward": "Reculer de 30 secondes",
    "skipForward": "Avancer de 30 secondes",
    "restart": "Recommencer depuis le début",
    "subtitlesOff": "Désactivés",
    "speed": "Vitesse",
    "subscription": {
      "requiredTitle": "Abonnement requis",
      "requiredMessage": "nécessite un abonnement payant",
      "upgradeInfo": "Mettez à niveau votre abonnement pour accéder au contenu premium",
      "upgrade": "Mettre à niveau"
    },
    "ai": {
      "dub": "Dub",
      "dubbing": "Doublage",
      "featuresTitle": "Fonctionnalités IA",
      "languagePrimary": "Principal",
      "languageSecondary": "Secondaire (facultatif)",
      "languageTitle": "Langue IA",
      "liveTranslate": "Traduction en direct",
      "selectLanguage": "Sélectionner la langue",
      "split": "Diviser",
      "togglePanel": "Afficher/Masquer le panneau IA",
      "translate": "Traduire",
      "trivia": "Anecdotes",
      "triviaToggle": "Anecdotes"
    },
    "catchup": {
      "description": "Vous avez manqué le début ? Obtenez un résumé généré par l'IA de ce qui s'est passé jusqu'ici.",
      "generateSummary": "Générer un résumé",
      "summaryTitle": "Résumé",
      "title": "Rattrapage",
      "keyPoints": "Points cles",
      "transcript": "Transcription"
    },
    "chat": {
      "title": "Chat en direct",
      "messagePlaceholder": "Saisissez un message..."
    },
    "companion": {
      "noContext": "Aucun contexte culturel disponible pour ce contenu pour le moment.",
      "quizComplete": "Quiz terminé",
      "quizRetry": "Réessayer",
      "quizStart": "Commencer le quiz",
      "quizTitle": "Prêt à tester vos connaissances ?",
      "quizTryAgain": "Réessayer",
      "tabContext": "Contexte",
      "tabQuiz": "Quiz",
      "tabVocabulary": "Vocabulaire",
      "tapWords": "Appuyez sur les mots dans les sous-titres pour les ajouter ici",
      "title": "Compagnon IA",
      "loadError": "Echec du chargement des donnees d'apprentissage"
    },
    "controls": {
      "audioTrack": "Piste audio",
      "continueWatching": "Continuer à regarder",
      "dismiss": "Ignorer",
      "goBack": "Retour",
      "navigateBack": "Retour",
      "on": "ON",
      "pause": "Pause",
      "play": "Lecture",
      "preview": "Aperçu",
      "selected": "Sélectionné",
      "send": "Envoyer",
      "skip": "Passer",
      "close": "Fermer",
      "exitFullscreen": "Quitter le plein ecran",
      "fullscreen": "Plein ecran",
      "restart": "Redemarrer",
      "skipBackward": "Reculer",
      "skipForward": "Avancer",
      "volume": "Volume"
    },
    "dubbing": {
      "notNow": "Pas maintenant",
      "premiumMessage": "Le doublage en direct nécessite un abonnement Premium ou Beta 500",
      "premiumTitle": "Fonctionnalité Premium",
      "upgrade": "Mettre à niveau",
      "voiceTitle": "Voix de doublage",
      "settings_title": "Paramètres de Doublage en Direct",
      "target_language": "Langue Cible"
    },
    "errors": {
      "streamLimitMessage": "Vous avez atteint le maximum de {{maxStreams}} diffusions simultanées. Veuillez arrêter une autre diffusion ou mettre à niveau votre forfait.",
      "streamLimitTitle": "Limite de diffusion atteinte",
      "upgradePlan": "Mettre à niveau le forfait"
    },
    "audio_description": "Description Audio",
    "dismiss": "Fermer",
    "scene_search": "Recherche de Scène",
    "search_placeholder": "Rechercher une scène...",
    "language_ratio": "Ratio d'Apprentissage Linguistique",
    "go_back": "Retour",
    "sleepTimer": {
      "title": "Minuterie de sommeil",
      "subtitle": "Pause automatique de la lecture après un délai défini",
      "minutes": "{{count}} min",
      "customPlaceholder": "Minutes personnalisées",
      "set": "Définir la minuterie",
      "remaining": "Sommeil dans {{time}}",
      "extend": "+15 min",
      "cancel": "Annuler la minuterie",
      "off": "Desactive",
      "setTimer": "Regler la minuterie"
    },
    "openSubs": {
      "title": "Rechercher des sous-titres",
      "searchPlaceholder": "Rechercher par titre...",
      "search": "Rechercher",
      "searchFailed": "Recherche échouée. Réessayez.",
      "downloads": "{{count}} téléchargements",
      "noResults": "Aucun sous-titre trouvé"
    },
    "dialogue": {
      "cancel": "Annuler",
      "close": "Fermer",
      "placeholder": "Tapez votre message...",
      "selectCharacter": "Choisir un personnage",
      "send": "Envoyer",
      "sharedSession": "Session partagee",
      "waitingForTurn": "En attente de votre tour...",
      "yourAvatar": "Votre avatar"
    },
    "interaction": {
      "next": "Suivant",
      "previous": "Precedent",
      "skip": "Ignorer",
      "start": "Démarrer l'interaction",
      "window": "Fenêtre d'interaction : {{duration}} secondes"
    },
    "pauseAsk": {
      "askAgain": "Redemander",
      "placeholder": "Posez une question sur cette scene...",
      "resume": "Reprendre",
      "resumeMovie": "Reprendre le film",
      "selectCharacter": "Choisir un personnage",
      "title": "Pause et question"
    },
    "phraseBreakdown": {
      "literal": "Littéral",
      "meaning": "Signification",
      "origin": "Origine",
      "funFact": "Anecdote",
      "usage": "Usage : {{level}}"
    },
    "translation": {
      "example": "Exemple :",
      "arrow": "→"
    },
    "subtitleMode": {
      "title": "Mode sous-titres",
      "modes": {
        "regular": {
          "name": "Standard",
          "description": "Sous-titres hébreux standards sans signes vocaliques"
        },
        "nikud": {
          "name": "Nikud",
          "description": "Hébreu avec signes vocaliques pour une lecture facilitée"
        },
        "shoresh": {
          "name": "Shoresh",
          "description": "Apprentissage par racines avec mise en évidence des origines"
        },
        "engrew": {
          "name": "Engrew",
          "description": "Translittération anglaise avec contexte hébreu"
        },
        "heblish": {
          "name": "Heblish",
          "description": "Anglais avec termes hébreux et contexte culturel"
        },
        "grammarFlip": {
          "name": "Inversion grammaticale",
          "description": "Structure de phrase hébraïque avec mots anglais"
        },
        "slangSynthesis": {
          "name": "Synthèse d'argot",
          "description": "Argot culturel et expressions idiomatiques expliqués"
        }
      }
    }
  },
  "empty": {
    "noContent": "Aucun contenu disponible",
    "tryAnotherCategory": "Essayez de sélectionner une autre catégorie",
    "noPodcasts": "Aucun podcast disponible",
    "tryLater": "Réessayez plus tard",
    "noResults": "Aucun résultat trouvé"
  },
  "content": {
    "play": "Lire",
    "addToList": "Ajouter à la liste",
    "inList": "Dans la liste",
    "details": "Détails",
    "synopsis": "Synopsis",
    "genre": "Genre",
    "genres": "Genres",
    "runtime": "Durée",
    "released": "Sortie",
    "director": "Réalisateur",
    "starring": "Avec",
    "cast": "Distribution",
    "season": "Saison",
    "seasons": "Saisons",
    "episode": "Épisode",
    "episodes": "Épisodes",
    "ep": "Ép",
    "selectSeason": "Sélectionner la saison",
    "noEpisodes": "Aucun épisode disponible",
    "noEpisodesAvailable": "Aucun épisode disponible à lire",
    "loadingSeries": "Chargement des informations de la série...",
    "votes": "votes",
    "rating": "Note",
    "imdbRating": "Note IMDB",
    "preview": "Aperçu",
    "previewPlaying": "Aperçu en cours",
    "trailerPlaying": "Bande-annonce en cours",
    "watchTrailer": "Voir la bande-annonce",
    "youMayAlsoLike": "Vous aimerez aussi",
    "relatedContent": "Contenu associé",
    "notFound": "Contenu non trouvé",
    "availableSubtitles": "Sous-titres disponibles",
    "subtitleSelected": "Sélectionné : {{language}}"
  },
  "breadcrumbs": {
    "series": "Séries",
    "movie": "Film",
    "watching": "En cours de visionnage",
    "channel": "Chaîne",
    "station": "Station",
    "podcast": "Podcast",
    "watchlist": "Liste de visionnage",
    "downloads": "Téléchargements"
  },
  "favorites": {
    "title": "Favoris",
    "items": "éléments",
    "empty": "Pas encore de favoris",
    "emptyHint": "Ajoutez des éléments à vos favoris"
  },
  "downloads": {
    "title": "Téléchargements",
    "items": "éléments",
    "storage": "Stockage",
    "empty": "Aucun téléchargement",
    "emptyHint": "Téléchargez du contenu pour le regarder hors ligne",
    "paused": "En pause"
  },
  "watchlist": {
    "filters": {
      "all": "Tout",
      "continue": "Continuer à regarder",
      "movies": "Films",
      "series": "Séries",
      "kids": "Enfants",
      "judaism": "Judaïsme",
      "podcasts": "Podcasts",
      "radio": "Radio"
    },
    "title": "Liste de lecture",
    "items": "éléments",
    "watched": "regardé",
    "empty": "Votre liste de lecture est vide",
    "emptyHint": "Commencez à regarder et les éléments apparaîtront ici"
  },
  "widgets": {
    "empty": "Pas encore de widgets",
    "emptyHint": "Vos widgets apparaîtront ici",
    "emptyPersonal": "Pas encore de widgets personnels",
    "emptyPersonalHint": "Créez votre premier widget personnel ou ajoutez des widgets système ci-dessus",
    "itemsTotal": "widgets au total",
    "systemWidgets": "Widgets système",
    "systemWidgetsHint": "Parcourez et ajoutez des widgets à votre collection",
    "myWidgets": "Mes widgets personnels",
    "myWidgetsHint": "Widgets que vous avez créés",
    "personalWidgets": "Mes widgets",
    "noSystemWidgets": "Aucun widget système disponible",
    "added": "Ajouté",
    "add": "Add",
    "remove": "Supprimer",
    "show": "Émission",
    "hidden": "Masqué",
    "addToCollection": "Ajouter à mes widgets",
    "removeFromCollection": "Retirer de mes widgets",
    "contentTypes": {
      "liveChannel": "Chaîne en direct",
      "iframe": "Contenu web",
      "podcast": "Podcast",
      "radio": "Radio",
      "vod": "Vidéo",
      "custom": "Personnalisé",
      "widget": "Widget"
    },
    "form": {
      "title": "Créer un widget",
      "basicInfo": "Informations de base",
      "titlePlaceholder": "Titre du widget",
      "titleRequired": "Le titre du widget est requis",
      "descriptionPlaceholder": "Description (facultatif)",
      "iconPlaceholder": "Icon emoji (e.g., 📺)",
      "content": "Contenu",
      "fromLibrary": "De la bibliothèque",
      "iframe": "iFrame",
      "selectContent": "Sélectionner du contenu (chaînes, podcasts, émissions, etc.)",
      "iframeUrl": "URL iFrame",
      "iframeUrlRequired": "L'URL de l'iFrame est requise",
      "iframeTitle": "Titre de l'iFrame",
      "positionSize": "Position et taille",
      "behavior": "Comportement",
      "mutedByDefault": "Son coupé par défaut",
      "closable": "Fermable",
      "draggable": "Déplaçable",
      "widgetOrder": "Ordre des widgets",
      "orderPlaceholder": "Ordre (0 = premier)",
      "saveWidget": "Sauvegarder le widget",
      "saving": "Sauvegarde...",
      "cancel": "Annuler",
      "change": "Modifier"
    }
  },
  "trending": {
    "title": "Tendances en Israël",
    "noTopics": "Aucun sujet tendance disponible",
    "topStory": "UNE DU JOUR",
    "sources": "Sources",
    "categories": {
      "security": "Sécurité",
      "politics": "Politique",
      "tech": "Tech",
      "culture": "Culture",
      "sports": "Sports",
      "economy": "Économie",
      "entertainment": "Divertissement",
      "weather": "Météo",
      "health": "Santé",
      "general": "Général"
    }
  },
  "cultures": {
    "title": "Cultures",
    "select": "Sélectionner une culture",
    "selectCulture": "Sélectionnez votre culture",
    "selectCultureDescription": "Choisissez une culture pour personnaliser votre contenu",
    "changeCulture": "Changer de culture",
    "israeli": {
      "name": "Israélienne",
      "description": "Contenu pour la communauté israélienne"
    },
    "chinese": {
      "name": "Chinoise",
      "description": "Contenu pour la communauté chinoise"
    },
    "japanese": {
      "name": "Japonaise",
      "description": "Contenu pour la communauté japonaise"
    },
    "korean": {
      "name": "Coréenne",
      "description": "Contenu pour la communauté coréenne"
    },
    "indian": {
      "name": "Indienne",
      "description": "Contenu pour la communauté indienne"
    }
  },
  "cultureTrending": {
    "whatsHotIn": "Tendances en {{location}}",
    "noTopics": "Aucun sujet tendance disponible",
    "sources": "Sources",
    "categories": {
      "security": "Sécurité",
      "politics": "Politique",
      "tech": "Tech",
      "technology": "Technologie",
      "culture": "Culture",
      "sports": "Sports",
      "economy": "Économie",
      "finance": "Finance",
      "entertainment": "Divertissement",
      "weather": "Météo",
      "health": "Santé",
      "food": "Cuisine",
      "fashion": "Mode",
      "travel": "Voyage",
      "history": "Historique",
      "expat": "Vie d'expatrié",
      "general": "Général"
    }
  },
  "cultureClock": {
    "timeIn": "Heure à {{location}}",
    "shabbat": "Chabbat",
    "weekend": "Week-end"
  },
  "cultureCities": {
    "connectionTo": "Connexion {{city}}",
    "explore": "Explorer {{city}}",
    "noContent": "Aucun contenu disponible",
    "categories": {
      "all": "Tout",
      "history": "Historique",
      "culture": "Culture",
      "finance": "Finance",
      "tech": "Tech",
      "food": "Gastronomie",
      "expat": "Vie d'expatrié",
      "news": "Actualités",
      "entertainment": "Divertissement"
    }
  },
  "clock": {
    "israel": "Israël",
    "local": "Local",
    "shabbatShalom": "Chabbat Chalom !",
    "erevShabbat": "Veille de Chabbat",
    "candleLighting": "Allumage des bougies",
    "parasha": "Parasha"
  },
  "ritual": {
    "title": "Rituel du matin",
    "greeting": "Bonjour !",
    "israelUpdate": "C'est l'après-midi en Israël, les informations rapportent les développements en cours",
    "recommendation": "Nous recommandons de commencer par les nouvelles du matin puis de passer à la radio",
    "preparingRitual": "Préparation de votre rituel matinal...",
    "israelTime": "Heure d'Israël",
    "day": "Day",
    "letsStart": "Commençons",
    "skipToday": "Passer pour aujourd'hui",
    "finish": "Terminer",
    "noContentNow": "Aucun contenu disponible actuellement",
    "typeLive": "En direct",
    "typeRadio": "Radio",
    "typeVideo": "Vidéo"
  },
  "watchParty": {
    "title": "Soirée visionnage",
    "create": "Créer une fête",
    "join": "Rejoindre la fête",
    "active": "Fête active",
    "createTitle": "Créer une soirée visionnage",
    "joinTitle": "Rejoindre la fête",
    "enterCode": "Entrer le code de salle",
    "roomCode": "Code de salle",
    "copyCode": "Copier le code",
    "codeCopied": "Code copié !",
    "participants": "Participants",
    "host": "Hôte",
    "you": "You",
    "leave": "Quitter la fête",
    "end": "Mettre fin à la fête",
    "chat": "Discussion",
    "sendMessage": "Envoyer un message",
    "typeMessage": "Saisissez un message...",
    "synced": "Synchronisé",
    "syncing": "Synchronisation...",
    "hostPaused": "Hôte en pause",
    "userJoined": "{{name}} a rejoint",
    "userLeft": "{{name}} a quitté",
    "partyEnded": "La fête est terminée",
    "connecting": "Connexion...",
    "options": {
      "chatEnabled": "Activer le chat",
      "syncPlayback": "Synchroniser la lecture"
    },
    "errors": {
      "invalidCode": "Code invalide",
      "partyFull": "La fête est complète",
      "partyEnded": "La fête est terminée",
      "connectionError": "Erreur de connexion",
      "createFailed": "Échec de la création de la fête",
      "joinFailed": "Échec de la connexion à la fête"
    },
    "audio": {
      "mute": "Couper le son",
      "unmute": "Réactiver le son",
      "speaking": "Parole",
      "connecting": "Connexion à l'audio...",
      "noAudio": "Audio non disponible"
    },
    "textOnlyMode": "Chat textuel uniquement",
    "endParty": "Mettre fin à la fête"
  },
  "footer": {
    "brandDescription": "Votre maison aux États-Unis. Émissions TV, VOD, radio et podcasts en hébreu.",
    "browse": "Parcourir",
    "account": "Compte",
    "support": "Support",
    "legal": "Légal",
    "location": "New York, États-Unis",
    "links": {
      "home": "Accueil",
      "liveTV": "TV en direct",
      "vod": "Films et Séries",
      "radio": "Radio",
      "podcasts": "Podcasts",
      "judaism": "Judaïsme",
      "profile": "Mon profil",
      "favorites": "Favoris",
      "watchlist": "Liste de lecture",
      "subscribe": "S'abonner",
      "downloads": "Téléchargements",
      "help": "Centre d'aide",
      "faq": "FAQ",
      "contact": "Nous contacter",
      "feedback": "Commentaires",
      "terms": "Conditions d'utilisation",
      "privacy": "Politique de confidentialité",
      "cookies": "Politique des cookies",
      "licenses": "Licences"
    },
    "newsletter": {
      "title": "Restez informé",
      "description": "Abonnez-vous à notre newsletter pour les dernières mises à jour et du contenu exclusif.",
      "placeholder": "Entrez votre e-mail",
      "success": "Merci de votre abonnement !"
    },
    "apps": {
      "title": "Obtenir l'application",
      "downloadOn": "Télécharger sur",
      "getItOn": "Télécharger sur",
      "appStore": "App Store",
      "googlePlay": "Google Play"
    },
    "social": {
      "facebook": "Facebook",
      "twitter": "Twitter",
      "instagram": "Instagram",
      "youtube": "YouTube"
    },
    "copyright": "© {{year}} Bayit+. Tous droits réservés.",
    "poweredBy": "Propulsé par",
    "sitemap": "Plan du site",
    "accessibility": "Accessibilité",
    "navigation": "Navigation",
    "liveTV": "TV en direct",
    "moviesAndSeries": "Films et séries",
    "radioStations": "Stations de radio",
    "myProfile": "Mon profil",
    "subscriptions": "Abonnements",
    "helpAndSupport": "Aide et support",
    "termsOfUse": "Conditions d'utilisation",
    "privacyPolicy": "Politique de confidentialité",
    "contactUs": "Contactez-nous"
  },
  "chapters": {
    "title": "Chapitres",
    "noChapters": "Aucun chapitre disponible",
    "generating": "Génération des chapitres...",
    "jumpTo": "Aller à",
    "current": "Now",
    "categories": {
      "intro": "Introduction",
      "news": "Actualités",
      "security": "Sécurité",
      "politics": "Politique",
      "economy": "Économie",
      "sports": "Sports",
      "weather": "Météo",
      "culture": "Culture",
      "conclusion": "Conclusion"
    },
    "chapterLabel": "Chapitre {{number}}",
    "chapter_number": "Chapitre {{number}}"
  },
  "admin": {
    "brand": {
      "title": "Admin Bayit+",
      "subtitle": "Gestion du système"
    },
    "backToApp": "Retour à l'application",
    "refunds": {
      "subtitle": "Gérer les demandes de remboursement",
      "approveModal": {
        "title": "Confirmer l'approbation",
        "message": "Approuver le remboursement de {{amount}} ?"
      },
      "confirmApprove": "Approuver le remboursement de {{amount}} ?",
      "confirmDelete": "Supprimer la demande de remboursement ?",
      "rejectModal": {
        "title": "Rejeter la demande de remboursement",
        "message": "Rejet du remboursement de {{amount}}",
        "reasonLabel": "Motif du rejet",
        "reasonPlaceholder": "Veuillez entrer le motif du rejet...",
        "submitButton": "Rejeter la demande"
      },
      "status": {
        "pending": "En attente",
        "approved": "Approuvé",
        "rejected": "Rejeté"
      },
      "columns": {
        "id": "ID",
        "user": "Utilisateur",
        "amount": "Montant",
        "reason": "Motif",
        "status": "Statut",
        "requestDate": "Date de demande"
      },
      "stats": {
        "pendingTitle": "En attente d'approbation",
        "approvedTitle": "Approuvé",
        "rejectedTitle": "Rejeté",
        "totalRefunded": "Total remboursé"
      },
      "emptyMessage": "Aucune demande de remboursement trouvée",
      "errors": {
        "rejectReasonRequired": "Veuillez entrer le motif du rejet"
      },
      "title": "Remboursements"
    },
    "plans": {
      "title": "Gestion des forfaits",
      "subtitle": "Configurer et gérer les forfaits d'abonnement",
      "createButton": "Nouveau forfait",
      "inactive": "Inactif",
      "subscribersLabel": "Abonnés :",
      "intervals": {
        "monthly": "mois",
        "yearly": "an"
      },
      "trialDays": "{{days}} jours d'essai",
      "modal": {
        "editTitle": "Modifier le forfait",
        "createTitle": "Nouveau forfait"
      },
      "form": {
        "nameEn": "Nom (Anglais)",
        "nameHe": "Nom (Hébreu)",
        "price": "Prix ($)",
        "interval": "Période de facturation",
        "trialDays": "Jours d'essai",
        "features": "Fonctionnalités (une par ligne)",
        "active": "Forfait actif"
      },
      "errors": {
        "requiredFields": "Le nom et le prix sont requis"
      },
      "confirmDelete": "Supprimer le forfait \"{{name}}\" ?"
    },
    "emailCampaigns": {
      "subtitle": "Créer et gérer les campagnes e-mail",
      "createButton": "Nouvelle campagne",
      "searchPlaceholder": "Rechercher une campagne...",
      "emptyMessage": "Aucune campagne trouvée",
      "status": {
        "draft": "Brouillon",
        "active": "Actif",
        "scheduled": "Planifiée",
        "completed": "Terminée"
      },
      "columns": {
        "name": "Nom de la campagne",
        "status": "Statut",
        "sent": "Envoyés",
        "opened": "Ouverts",
        "clicked": "Cliqués",
        "created": "Créée",
        "actions": "Actions"
      },
      "editModal": {
        "title": "Modifier la campagne"
      },
      "sendTestEmail": "Envoyer un test",
      "confirmSend": "Envoyer la campagne \"{{name}}\" ?",
      "confirmDelete": "Supprimer la campagne \"{{name}}\" ?",
      "testEmailSent": "E-mail de test envoyé !",
      "createModal": {
        "title": "Nouvelle campagne e-mail"
      },
      "form": {
        "name": "Nom de la campagne",
        "namePlaceholder": "ex: Soldes de fin d'année",
        "subject": "Objet de l'e-mail",
        "subjectPlaceholder": "Objet affiché aux destinataires",
        "body": "Contenu",
        "bodyPlaceholder": "Contenu de l'e-mail...",
        "submitButton": "Créer la campagne",
        "requiredFields": "Le nom et l'objet sont requis"
      },
      "testModal": {
        "title": "Envoyer un e-mail de test",
        "emailLabel": "Adresse e-mail",
        "emailPlaceholder": "test@exemple.com",
        "submitButton": "Envoyer le test"
      },
      "errors": {
        "requiredFields": "Le nom et l'objet sont requis"
      }
    },
    "dashboard": {
      "subtitle": "Aperçu du système",
      "refresh": "Actualiser",
      "timeAgo": {
        "minutes": "il y a {{count}} minutes",
        "hours": "il y a {{count}} heures"
      },
      "title": "Tableau de bord",
      "users": "Utilisateurs",
      "revenue": "Revenus",
      "subscriptions": "Abonnements",
      "recentActivity": "Activité récente",
      "quickActions": "Actions rapides"
    },
    "common": {
      "all": "Tout",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "active": "Actif",
      "back": "Retour",
      "filterAction": "Action",
      "filterResource": "Ressource",
      "filterUser": "Utilisateur",
      "filterDateRange": "Période"
    },
    "stats": {
      "totalUsers": "Utilisateurs totaux",
      "activeUsers": "Utilisateurs actifs",
      "newToday": "Nouveaux aujourd'hui",
      "newThisWeek": "Nouveaux cette semaine",
      "totalRevenue": "Revenus totaux",
      "revenueToday": "Revenus aujourd'hui",
      "revenueMonth": "Revenus ce mois",
      "arpu": "Revenu moyen par utilisateur",
      "activeSubscriptions": "Abonnements actifs",
      "churnRate": "Taux de désabonnement"
    },
    "actions": {
      "new": "Nouveau",
      "addUser": "Ajouter un utilisateur",
      "newCampaign": "Nouvelle campagne",
      "sendEmail": "Envoyer un e-mail",
      "viewReports": "Voir les rapports"
    },
    "auditActions": {
      "user_created": "Utilisateur créé",
      "user_updated": "Utilisateur mis à jour",
      "user_deleted": "Utilisateur supprimé",
      "user_role_changed": "Rôle utilisateur modifié",
      "campaign_created": "Campagne créée",
      "campaign_updated": "Campagne mise à jour",
      "campaign_deleted": "Campagne supprimée",
      "campaign_activated": "Campagne activée",
      "subscription_created": "Abonnement créé",
      "subscription_updated": "Abonnement mis à jour",
      "subscription_canceled": "Abonnement annulé",
      "subscription_deleted": "Abonnement supprimé",
      "refund_processed": "Remboursement traité",
      "payment_received": "Paiement reçu",
      "settings_updated": "Paramètres mis à jour",
      "login": "Connexion",
      "logout": "Déconnexion",
      "content_created": "Contenu créé",
      "content_updated": "Contenu mis à jour",
      "content_deleted": "Contenu supprimé",
      "content_published": "Contenu publié",
      "content_unpublished": "Contenu dépublié",
      "category_created": "Catégorie créée",
      "category_updated": "Catégorie mise à jour",
      "category_deleted": "Catégorie supprimée",
      "live_channel_created": "Chaîne en direct créée",
      "live_channel_updated": "Chaîne en direct mise à jour",
      "live_channel_deleted": "Chaîne en direct supprimée",
      "radio_station_created": "Station de radio créée",
      "radio_station_updated": "Station de radio mise à jour",
      "radio_station_deleted": "Station de radio supprimée",
      "podcast_created": "Podcast créé",
      "podcast_updated": "Podcast mis à jour",
      "podcast_deleted": "Podcast supprimé",
      "podcast_episode_created": "Épisode de podcast créé",
      "podcast_episode_updated": "Épisode de podcast mis à jour",
      "podcast_episode_deleted": "Épisode de podcast supprimé",
      "content_imported": "Contenu importé",
      "widget_created": "Widget créé",
      "widget_updated": "Widget mis à jour",
      "widget_deleted": "Widget supprimé",
      "widget_published": "Widget publié",
      "widget_unpublished": "Widget dépublié"
    },
    "placeholder": {
      "userId": "Entrer l'ID utilisateur",
      "discount": "0"
    },
    "titles": {
      "users": "Utilisateurs",
      "transactions": "Transactions",
      "subscriptions": "Abonnements",
      "refunds": "Remboursements",
      "plans": "Forfaits",
      "campaigns": "Campagnes",
      "auditLogs": "Journaux d'audit",
      "pushNotifications": "Notifications push",
      "billing": "Facturation",
      "marketing": "Marketing",
      "content": "Bibliothèque de contenu",
      "categories": "Catégories",
      "liveChannels": "Chaînes en direct",
      "radioStations": "Stations de radio",
      "podcasts": "Podcasts",
      "settings": "Paramètres"
    },
    "nav": {
      "dashboard": "Tableau de bord",
      "users": "Utilisateurs",
      "campaigns": "Campagnes",
      "billing": "Facturation",
      "billingOverview": "Aperçu",
      "transactions": "Transactions",
      "refunds": "Remboursements",
      "subscriptions": "Abonnements",
      "subscriptionsList": "Abonnés",
      "plans": "Forfaits",
      "marketing": "Marketing",
      "marketingDashboard": "Aperçu",
      "emailCampaigns": "Campagnes e-mail",
      "pushNotifications": "Notifications push",
      "content": "Contenu",
      "contentLibrary": "Bibliothèque de contenu",
      "categories": "Catégories",
      "liveChannels": "Chaînes en direct",
      "radioStations": "Stations de radio",
      "podcasts": "Podcasts",
      "widgets": "Widgets",
      "recordings": "Enregistrements",
      "uploads": "Téléversements",
      "settings": "Paramètres",
      "auditLogs": "Journaux d'audit",
      "librarian": "Agent Bibliothécaire",
      "featured": "Mise en avant"
    },
    "featured": {
      "title": "Contenu mis en avant",
      "subtitle": "Gérer le contenu mis en avant pour les carrousels de la page d'accueil",
      "empty": "Aucun contenu mis en avant",
      "emptyHint": "Les éléments mis en avant apparaîtront dans leurs carrousels respectifs sur la page d'accueil",
      "count": "{{count}} éléments",
      "confirmUnfeature": "Retirer de la mise en avant ?",
      "remove": "Retirer",
      "unsavedChanges": "Vous avez des modifications non enregistrées",
      "section": {
        "title": "{{name}}",
        "itemCount": "{{count}} élément",
        "itemCount_plural": "{{count}} éléments",
        "empty": "Aucun élément mis en avant",
        "emptyHint": "Les éléments mis en avant apparaîtront dans le carrousel {{name}} sur la page d'accueil"
      },
      "saveButton": "Enregistrer {{count}} section",
      "saveButton_plural": "Enregistrer {{count}} sections",
      "saving": "Enregistrement...",
      "saveSuccess": "Contenu mis en avant mis à jour avec succès",
      "saveFailed": "Échec de l'enregistrement du contenu mis en avant",
      "removeConfirm": "Retirer de {{section}} ?",
      "removeSuccess": "Retiré de {{section}}"
    },
    "recordings": {
      "title": "Gestion des enregistrements",
      "subtitle": "Gérer les enregistrements des utilisateurs sur la plateforme",
      "totalRecordings": "Enregistrements totaux",
      "totalStorage": "Stockage total",
      "totalUsers": "Utilisateurs avec enregistrements",
      "activeSessions": "Sessions actives",
      "searchPlaceholder": "Rechercher par titre, utilisateur ou chaîne...",
      "user": "Utilisateur",
      "confirmDelete": "Supprimer l'enregistrement '{{title}}' ? Cette action est irréversible.",
      "deleteRecording": "Supprimer l'enregistrement",
      "deleteSuccess": "Enregistrement supprimé avec succès",
      "deleteFailed": "Échec de la suppression de l'enregistrement",
      "loadFailed": "Échec du chargement des enregistrements",
      "noRecordings": "Aucun enregistrement trouvé",
      "noRecordingsHint": "Aucun enregistrement utilisateur dans le système pour le moment."
    },
    "uploads": {
      "title": "Gestion des téléversements",
      "subtitle": "Gérer les téléversements de contenu et la surveillance automatique des dossiers",
      "activeUploads": "Téléversements actifs",
      "noActiveUploads": "Aucun téléversement actif",
      "queuedUploads": "Téléversements en file d'attente",
      "queued": "En file d'attente",
      "andMore": "Et {{count}} de plus",
      "monitoredFolders": "Dossiers surveillés",
      "noMonitoredFolders": "Aucun dossier surveillé configuré",
      "configureFoldersHelp": "Cliquez sur 'Ajouter un dossier' pour configurer les dossiers surveillés pour les téléversements automatiques",
      "addFolder": "Ajouter un dossier",
      "editFolder": "Modifier le dossier",
      "deleteFolder": "Supprimer le dossier",
      "confirmDelete": "Supprimer ce dossier ?",
      "triggerUpload": "Déclencher le téléversement",
      "triggerUploadSuccess": "{{files_found}} nouveaux fichiers trouvés à téléverser",
      "triggerUploadFailed": "Échec du déclenchement de l'analyse",
      "noFilesFound": "Aucun nouveau fichier trouvé dans les dossiers surveillés",
      "sessionIssue": "Problème de session",
      "sessionIssueHelp": "Votre session a peut-être expiré. Veuillez actualiser la page pour restaurer la connexion.",
      "sessionExpired": "Session expirée. Veuillez actualiser la page ou vous reconnecter.",
      "unauthorized": "Session invalide. Veuillez actualiser la page.",
      "endpointNotFound": "Service de téléversement non disponible. Vérifiez la configuration du serveur.",
      "timeout": "L'analyse de téléversement a expiré. Réessayez ou vérifiez les dossiers surveillés.",
      "wsDisconnected": "Mises à jour en temps réel désactivées",
      "wsDisconnectedHelp": "La connexion WebSocket a échoué. L'état de la file d'attente peut être obsolète. La page réessaiera automatiquement.",
      "wsReconnecting": "Reconnexion aux mises à jour en temps réel...",
      "uploadAlreadyRunning": "Analyse de téléversement déjà en cours. Veuillez attendre la fin des téléversements actuels.",
      "uploadsActiveNotice": "Téléversements en cours ({{processing}} actifs, {{queued}} en attente). Nouvelle analyse désactivée jusqu'à la fin du lot actuel.",
      "clearQueue": "Vider la file d'attente",
      "clearQueueConfirmTitle": "Vider la file d'attente ?",
      "clearQueueConfirmMessage": "Cela annulera {{count}} tâche(s) active(s). Cette action est irréversible.",
      "clearQueueSuccess": "File d'attente vidée avec succès",
      "clearQueueFailed": "Échec du vidage de la file d'attente",
      "cancelUpload": "Annuler",
      "cancelUploadConfirm": "Annuler ce téléversement ?",
      "cancelUploadSuccess": "Téléversement annulé",
      "cancelUploadFailed": "Échec de l'annulation du téléversement",
      "resetCache": "Réinitialiser le cache",
      "cacheResetSuccess": "Cache vidé : {{count}} fichiers seront réanalysés lors de la prochaine analyse",
      "cacheResetFailed": "Échec de la réinitialisation du cache",
      "contentTypeFilters": "Filtres de type de contenu",
      "contentTypeFiltersHelp": "Optionnel - Laissez tout décoché pour traiter tous les types de contenu",
      "moviesOnly": "Films uniquement",
      "seriesOnly": "Séries uniquement",
      "audiobooksOnly": "Livres audio uniquement",
      "type": "Type",
      "lastScan": "Dernière analyse",
      "systemInfo": "Informations sur le système de téléversement",
      "systemInfoText": "Extrait automatiquement les sous-titres des fichiers vidéo locaux pendant le téléversement pour un traitement plus rapide",
      "languagesInfo": "Langues de sous-titres prises en charge : Anglais (en), Hébreu (he), Espagnol (es)",
      "queueStatus": "File d'attente de téléversement",
      "totalJobs": "Total",
      "processing": "Actif",
      "completed": "Terminé",
      "skipped": "Ignoré",
      "failed": "Échoué",
      "queuePaused": "File d'attente en pause",
      "resumeQueue": "Reprendre",
      "activeUpload": "Téléversement actif",
      "queuedItems": "En file d'attente",
      "noQueuedItems": "Aucun élément en file d'attente",
      "addedAt": "Ajouté",
      "recentCompleted": "Récemment terminés",
      "stages": {
        "browserUpload": "Téléversement vers le serveur",
        "hashCalculation": "Calcul du hash",
        "duplicateCheck": "Vérification des doublons",
        "metadataExtraction": "Extraction des métadonnées",
        "gcsUpload": "Téléversement vers le cloud",
        "databaseInsert": "Enregistrement en base de données",
        "imdbLookup": "Récupération des infos IMDB",
        "subtitleExtraction": "Extraction des sous-titres",
        "completed": "Terminé",
        "failed": "Échoué",
        "skipped": "Ignoré"
      },
      "form": {
        "name": "Nom du dossier",
        "namePlaceholder": "Mon dossier de films",
        "path": "Chemin du dossier",
        "pathHelp": "Entrez le chemin serveur vers le dossier (ex: /Volumes/USB Drive/Movies)",
        "contentType": "Type de contenu",
        "enabled": "Activé",
        "autoUpload": "Téléversement automatique"
      },
      "contentTypes": {
        "movie": "Films",
        "series": "Séries",
        "audiobook": "Livres audio"
      },
      "errors": {
        "pathRequired": "Le chemin du dossier est requis"
      },
      "manualUpload": {
        "title": "Téléversement manuel",
        "subtitle": "Glissez-déposez des fichiers ou sélectionnez un dossier",
        "dropHere": "Déposez les fichiers ici ou cliquez pour parcourir",
        "dropHereActive": "Déposez les fichiers pour les ajouter",
        "selectFolder": "Sélectionner un dossier",
        "supportedFormats": "Formats vidéo pris en charge (mp4, mkv, avi, mov, webm)",
        "selectedFiles": "Fichiers sélectionnés",
        "noFilesSelected": "Aucun fichier sélectionné",
        "clearAll": "Tout effacer",
        "uploadSelected": "Téléverser la sélection",
        "selectContentType": "Sélectionnez le type de contenu à téléverser",
        "uploadingFiles": "Ajout de {{count}} fichier(s) à la file d'attente...",
        "uploadSuccess": "{{count}} fichier(s) ajouté(s) à la file d'attente avec succès",
        "uploadFailed": "Échec de l'ajout des fichiers à la file d'attente",
        "fileSize": "Taille",
        "removeFile": "Supprimer",
        "invalidFileType": "Type de fichier invalide. Seuls les fichiers vidéo sont pris en charge.",
        "filesCount": "{{count}} fichier(s) sélectionné(s)",
        "pendingRestore": "{{count}} fichier(s) en attente de la session précédente",
        "pendingRestoreHint": "Déposez ou sélectionnez les mêmes fichiers pour restaurer votre file d'attente"
      }
    },
    "librarian": {
      "title": "Agent Bibliothécaire",
      "subtitle": "Gestion autonome de la bibliothèque de contenu alimentée par l'IA",
      "loading": "Chargement de l'Agent Bibliothécaire...",
      "loadingConfig": "Chargement de la configuration...",
      "refresh": "Actualiser",
      "errors": {
        "configError": "Erreur de configuration",
        "configNotLoaded": "Configuration non chargée",
        "failedToLoad": "Échec du chargement des données du bibliothécaire",
        "failedToLoadConfig": "Échec du chargement de la configuration du bibliothécaire",
        "failedToTrigger": "Échec du déclenchement de l'audit. Veuillez réessayer.",
        "failedToLoadDetails": "Échec du chargement des détails du rapport.",
        "failedToRollback": "Échec de l'annulation de l'action.",
        "failedToClearReports": "Échec de l'effacement des rapports d'audit. Veuillez réessayer.",
        "failedToPause": "Échec de la mise en pause de l'audit",
        "failedToResume": "Échec de la reprise de l'audit",
        "failedToCancel": "Échec de l'annulation de l'audit",
        "failedToInterject": "Échec de l'envoi du message à l'agent IA",
        "auditAlreadyRunning": "Un audit est déjà en cours. Veuillez attendre qu'il se termine ou l'annuler avant d'en lancer un nouveau.",
        "budgetExceeded": "Limite de budget mensuel dépassée. Impossible d'exécuter l'audit.",
        "contactAdmin": "La page Bibliothécaire ne peut pas se charger sans configuration appropriée.\nVeuillez contacter votre administrateur."
      },
      "stats": {
        "systemHealth": "Santé du système",
        "totalAudits": "Audits totaux (30j)",
        "last30Days": "30 derniers jours",
        "issuesFixed": "Problèmes corrigés",
        "lastAudit": "Dernier audit",
        "never": "Jamais",
        "unknown": "inconnu"
      },
      "health": {
        "excellent": "excellent",
        "good": "bon",
        "fair": "correct",
        "poor": "mauvais",
        "unknown": "inconnu"
      },
      "quickActions": {
        "title": "Configuration d'exécution",
        "subtitle": "Configurer et déclencher des audits",
        "auditMode": "Mode d'audit",
        "auditModeHelp": "Choisissez quoi vérifier",
        "dryRun": "Mode aperçu",
        "dryRunHelp": "Afficher ce qui changerait sans apporter de modifications",
        "scopeFilters": "Capacités d'audit",
        "scopeFiltersHelp": "Sélectionnez les capacités à activer (plusieurs peuvent être combinées)",
        "last24Hours": "Contenu récent uniquement",
        "last24HoursHelp": "Limiter l'audit au contenu ajouté dans les dernières 24 heures",
        "cybTitlesOnly": "Nettoyer les titres",
        "cybTitlesOnlyHelp": "Supprimer les extensions de fichiers, marqueurs de qualité et tags de version des titres",
        "tmdbPostersOnly": "Affiches et métadonnées TMDB",
        "tmdbPostersOnlyHelp": "Récupérer les affiches, descriptions et métadonnées manquantes depuis TMDB",
        "openSubtitlesEnabled": "Acquérir des sous-titres",
        "openSubtitlesEnabledHelp": "Télécharger les sous-titres manquants depuis OpenSubtitles (HE/EN/ES)",
        "classifyOnly": "Vérifier la classification",
        "classifyOnlyHelp": "Vérifier et corriger les erreurs de classification film vs série",
        "purgeDuplicates": "Supprimer les doublons",
        "purgeDuplicatesHelp": "Trouver et supprimer les contenus en double",
        "auditType": "Type d'audit",
        "auditTypeHelp": "Choisissez entre un audit basé sur des règles ou alimenté par l'IA",
        "dailyAudit": "Audit quotidien",
        "dailyBadge": "Basé sur des règles • Rapide • Gratuit",
        "dailyDescription": "Exécute des vérifications prédéfinies sur le contenu modifié dans les 7 derniers jours. Rapide et prévisible, sans coûts IA.",
        "aiAgentAudit": "Audit Agent IA",
        "aiAgentBadge": "Alimenté par l'IA • Intelligent • Utilise le budget",
        "aiAgentDescription": "Agent IA autonome (Claude) prend des décisions intelligentes sur quoi vérifier et corriger. Plus complet mais utilise le budget API.",
        "triggerDaily": "Exécuter l'audit quotidien",
        "triggerAI": "Exécuter l'audit Agent IA",
        "auditRunningNotice": "Un audit est en cours. Les boutons seront activés une fois terminé.",
        "budgetLabel": "Limite de budget Agent IA : {{budget}} $",
        "budgetPerAudit": "Budget par audit",
        "monthlyBudgetUsed": "Budget utilisé (30j)",
        "monthlyBudgetLimit": "/ {{limit}} $ mensuel",
        "budgetWarning": "L'exécution de cet audit dépasserait la limite de budget mensuel",
        "aiAuditSuccess": "Audit Agent IA déclenché avec succès. {{dryRun}}",
        "dailyAuditSuccess": "Audit quotidien déclenché avec succès. {{dryRun}}",
        "dryRunMode": "(Mode aperçu)",
        "rollbackSuccess": "Action annulée avec succès."
      },
      "voice": {
        "title": "Contrôle vocal",
        "description": "Utilisez votre voix pour donner des commandes au bibliothécaire. Appuyez simplement sur le bouton et parlez naturellement.",
        "pressToSpeak": "Appuyez pour parler",
        "listening": "Écoute...",
        "transcript": "Transcription",
        "processing": "Traitement de votre commande...",
        "speaking": "Le bibliothécaire répond...",
        "examples": "Exemples de commandes",
        "example1": "Vérifier les affiches manquantes dans les dernières 24 heures",
        "example2": "Corriger les métadonnées des titres CYB",
        "example3": "Analyser les URLs de streaming cassées",
        "example4": "Extraire les sous-titres des films",
        "notSupported": "La reconnaissance vocale n'est pas prise en charge dans votre navigateur. Veuillez utiliser Chrome, Edge ou Safari.",
        "notAvailable": "Le contrôle vocal n'est pas disponible",
        "noSpeech": "Aucune parole détectée. Veuillez réessayer.",
        "noMicrophone": "Aucun microphone détecté. Veuillez vérifier votre appareil.",
        "microphoneBlocked": "L'accès au microphone a été bloqué. Veuillez l'activer dans les paramètres de votre navigateur.",
        "error": "Erreur de reconnaissance vocale : {{error}}",
        "startFailed": "Échec du démarrage de la reconnaissance vocale. Veuillez réessayer.",
        "commandFailed": "Échec de l'exécution de la commande. Veuillez réessayer."
      },
      "schedules": {
        "title": "Audits planifiés",
        "subtitle": "Configurer les planifications d'audit quotidiennes et hebdomadaires",
        "dailyTitle": "Audit quotidien",
        "weeklyTitle": "Audit IA hebdomadaire",
        "schedule": "Planification",
        "time": "Heure",
        "mode": "Mode",
        "cost": "Coût est.",
        "status": "Statut",
        "description": "Description",
        "viewInConsole": "Voir dans Cloud Console",
        "modifyNote": "Pour modifier les planifications, utilisez Google Cloud Console",
        "editTitle": "Modifier la planification",
        "editNotAvailable": "Modification de planification non disponible",
        "editNotAvailableMessage": "Les modifications de planification nécessitent l'intégration de l'API Cloud Scheduler. Veuillez utiliser le bouton 'Voir dans Cloud Console' pour modifier les planifications directement dans Google Cloud Console.",
        "cronExpression": "Expression Cron",
        "cronHint": "Format : minute heure jour mois jour_semaine (ex: 0 2 * * * = quotidien à 2h00)",
        "patterns": {
          "daily": "Quotidien à {{hour}}:{{minute}}",
          "weekly": "Chaque {{day}} à {{hour}}:{{minute}}"
        },
        "days": {
          "sunday": "Dimanche",
          "monday": "Lundi",
          "tuesday": "Mardi",
          "wednesday": "Mercredi",
          "thursday": "Jeudi",
          "friday": "Vendredi",
          "saturday": "Samedi"
        }
      },
      "reports": {
        "title": "Rapports d'audit récents",
        "emptyMessage": "Aucun rapport d'audit pour le moment",
        "totalReports": "{{count}} rapport(s)",
        "clearAll": "Tout effacer",
        "confirmClearAll": "Êtes-vous sûr de vouloir effacer tous les rapports d'audit ? Cette action est irréversible.",
        "clearedSuccessfully": "Tous les rapports d'audit effacés avec succès",
        "viewLogs": "Voir les journaux",
        "viewDetails": "Voir les détails",
        "columns": {
          "date": "Date",
          "type": "Type",
          "duration": "Durée",
          "status": "Statut",
          "issues": "Problèmes",
          "fixes": "Corrections",
          "actions": "Actions"
        },
        "detailModal": {
          "title": "Rapport d'audit : {{id}}",
          "summary": "Résumé",
          "status": "Statut",
          "executionTime": "Temps d'exécution",
          "totalItems": "Éléments totaux",
          "healthyItems": "Éléments sains",
          "issuesFound": "Problèmes trouvés",
          "totalIssues": "Problèmes totaux trouvés",
          "seeInsightsBelow": "Voir les Insights IA ci-dessous pour les détails",
          "brokenStreams": "Flux cassés",
          "missingMetadata": "Métadonnées manquantes",
          "misclassifications": "Mauvaises classifications",
          "orphanedItems": "Éléments orphelins",
          "fixesApplied": "Corrections appliquées",
          "totalFixes": "{{count}} corrections au total",
          "aiInsights": "Insights IA"
        }
      },
      "logs": {
        "title": "Journaux d'exécution",
        "liveAuditLog": "Journal d'audit en direct",
        "executionLog": "Journal d'exécution d'audit",
        "searchPlaceholder": "Rechercher dans les journaux...",
        "noLogs": "Aucun journal à afficher",
        "noActiveAudit": "Aucun audit actif",
        "triggerAuditToSee": "Déclenchez un audit pour voir les journaux d'exécution en direct ici",
        "auditType": "Type d'audit",
        "started": "Démarré",
        "completed": "Terminé",
        "lastLog": "Dernier journal",
        "staleWarning": "Aucun nouveau journal depuis {{seconds}}s - la tâche peut être en traitement ou bloquée",
        "pollingStatus": "Interrogation active • Dernière vérification",
        "connecting": "Connexion au journal d'audit en direct...",
        "aiInsightPrefix": "Insight IA",
        "source": {
          "librarian": "Bibliothécaire",
          "aiAgent": "Agent IA"
        },
        "levels": {
          "debug": "DÉBOGAGE",
          "info": "INFO",
          "warn": "AVERT",
          "error": "ERREUR",
          "success": "SUCCÈS",
          "trace": "TRACE"
        },
        "auditStarted": "Audit démarré",
        "brokenStreamsFound": "{{count}} flux cassé(s) trouvé(s)",
        "missingMetadataFound": "{{count}} élément(s) avec métadonnées manquantes trouvé(s)",
        "misclassificationsFound": "{{count}} élément(s) mal classifié(s) trouvé(s)",
        "orphanedItemsFound": "{{count}} élément(s) orphelin(s) trouvé(s)",
        "fixesApplied": "{{count}} correction(s) appliquée(s)",
        "auditCompleted": "Audit {{status}} en {{duration}}s",
        "auditInitializing": "Initialisation de l'audit {{auditType}}...",
        "dryRunMode": "Exécution en mode APERÇU - aucune modification ne sera apportée",
        "liveMode": "Exécution en mode LIVE - les modifications seront appliquées",
        "budgetSet": "Limite de budget : {{budget}} $",
        "connectingToAgent": "Connexion à l'Agent IA Claude..."
      },
      "audit": {
        "types": {
          "aiAgent": "Agent IA",
          "dailyIncremental": "Incrémental quotidien"
        },
        "pause": "Pause",
        "resume": "Reprendre",
        "cancel": "Annuler",
        "interject": "Intervenir",
        "interjectTitle": "Envoyer un message à l'Agent IA",
        "interjectHint": "Ce message sera injecté dans la conversation de l'agent IA à la prochaine itération. Utilisez-le pour fournir un contexte supplémentaire, rediriger l'attention ou donner des instructions spécifiques.",
        "interjectPlaceholder": "ex: Concentrez-vous uniquement sur les films, ignorez les séries pour l'instant...",
        "sendInterject": "Envoyer",
        "interjectSuccess": "Message envoyé à l'agent IA avec succès",
        "pauseSuccess": "Audit mis en pause avec succès",
        "resumeSuccess": "Audit repris avec succès",
        "cancelSuccess": "Audit annulé avec succès"
      },
      "progress": {
        "batch": "Lot {{current}} sur {{total}}",
        "items": "{{processed}} sur {{total}} éléments",
        "finishing": "Finalisation...",
        "finalizing": "Génération du rapport et application des corrections"
      },
      "activityLog": {
        "title": "Journal d'activité",
        "subtitle": "{{count}} actions enregistrées",
        "filterByType": "Filtrer par type",
        "allActions": "Toutes les actions",
        "content": "Contenu",
        "noDescription": "Aucune description disponible",
        "updatedFields": "Champs mis à jour : {{fields}}",
        "pagination": "Page {{page}} sur {{totalPages}}",
        "issueType": "Type de problème",
        "confidence": "Confiance",
        "autoApproved": "Approuvé automatiquement",
        "changes": "Modifications",
        "actionTypes": {
          "addPoster": "Ajouter une affiche",
          "updateMetadata": "Mettre à jour les métadonnées",
          "recategorize": "Recatégoriser",
          "fixUrl": "Corriger l'URL",
          "cleanTitle": "Nettoyer le titre",
          "classify": "Classifier"
        },
        "rollback": "Annuler",
        "rolledBack": "Annulé",
        "confirmRollback": {
          "title": "Confirmer l'annulation",
          "message": "Êtes-vous sûr de vouloir annuler cette action ? Cela restaurera l'état précédent."
        },
        "emptyMessage": "Aucune action trouvée"
      },
      "modal": {
        "confirmAI": {
          "title": "Déclencher l'audit Agent IA ?",
          "message": "Cela déclenchera un audit d'agent IA autonome avec une limite de budget de {{budget}} $. L'agent prendra des décisions sur quoi vérifier et corriger. {{dryRun}}",
          "dryRunNote": "Exécution en mode APERÇU (aucune modification ne sera apportée)."
        },
        "cancel": "Annuler",
        "confirm": "Confirmer",
        "close": "Fermer",
        "retry": "Réessayer"
      },
      "status": {
        "enabled": "ACTIVÉ",
        "disabled": "DÉSACTIVÉ",
        "completed": "Audit terminé",
        "failed": "Audit échoué",
        "in_progress": "En cours",
        "partial": "Partiellement terminé",
        "pending": "En attente",
        "running": "En cours d'exécution"
      },
      "auditTypes": {
        "daily_incremental": "incrémental quotidien",
        "ai_agent": "Agent IA"
      }
    },
    "widgets": {
      "title": "Widgets",
      "subtitle": "Gérer les widgets flottants pour les flux en direct et les contenus intégrés",
      "newWidget": "Nouveau widget",
      "editWidget": "Modifier le widget",
      "columns": {
        "title": "Titre",
        "contentType": "Type de contenu",
        "targetRoles": "Rôles cibles",
        "targetPages": "Pages cibles",
        "status": "Statut",
        "order": "Ordre"
      },
      "contentTypes": {
        "liveChannel": "Chaîne en direct",
        "live": "En direct",
        "vod": "Vidéo à la demande",
        "podcast": "Podcast",
        "radio": "Radio",
        "iframe": "Iframe"
      },
      "status": {
        "active": "Actif",
        "inactive": "Inactif"
      },
      "form": {
        "title": "Titre du widget",
        "description": "Description (optionnel)",
        "icon": "Emoji icône (optionnel)",
        "contentType": "Type de contenu",
        "selectChannel": "Sélectionner une chaîne en direct",
        "channelPlaceholder": "-- Sélectionner une chaîne --",
        "iframeUrl": "URL Iframe",
        "iframeTitle": "Titre iframe (pour l'accessibilité)",
        "position": "Position par défaut",
        "behavior": "Comportement",
        "mutedByDefault": "Muet par défaut",
        "closable": "Fermable",
        "draggable": "Déplaçable",
        "targetPages": "Pages cibles (séparées par des virgules, vide = toutes)",
        "targetPagesPlaceholder": "/, /live, /vod",
        "order": "Ordre"
      },
      "actions": {
        "save": "Enregistrer",
        "cancel": "Annuler"
      },
      "confirmDelete": "Êtes-vous sûr de vouloir supprimer ce widget ?",
      "emptyMessage": "Aucun widget trouvé. Créez-en un pour commencer.",
      "allPages": "Toutes les pages",
      "allRoles": "Tous",
      "errors": {
        "titleRequired": "Le titre est requis",
        "selectChannel": "Veuillez sélectionner une chaîne en direct",
        "iframeUrlRequired": "L'URL iframe est requise"
      }
    },
    "billing": {
      "subtitle": "Suivre les revenus et les paiements",
      "revenue": "Revenus",
      "today": "Aujourd'hui",
      "thisWeek": "Cette semaine",
      "thisMonth": "Ce mois",
      "thisYear": "Cette année",
      "metrics": "Indicateurs clés",
      "totalTransactions": "Transactions totales",
      "avgTransaction": "Transaction moyenne",
      "pendingRefunds": "Remboursements en attente",
      "refundRate": "Taux de remboursement",
      "retention": "Rétention",
      "retentionRate": "Taux de rétention",
      "churnRate": "Taux de désabonnement",
      "atRiskUsers": "Utilisateurs à risque",
      "churnedUsers": "Utilisateurs désabonnés",
      "quickLinks": "Liens rapides"
    },
    "marketing": {
      "recentCampaigns": "Campagnes récentes",
      "audienceSegments": "Segments d'audience",
      "emailMetrics": "Métriques e-mail",
      "pushMetrics": "Métriques push",
      "quickActions": "Actions rapides"
    },
    "push": {
      "titlePlaceholder": "Titre de la notification",
      "bodyPlaceholder": "Message de la notification"
    },
    "auditLogs": {
      "subtitle": "Suivre toutes les actions du système",
      "filter": "Filtrer",
      "export": "Exporter",
      "all": "Tout",
      "advancedFiltering": "Filtrage avancé",
      "actionType": "Type d'action",
      "clear": "Effacer",
      "apply": "Appliquer",
      "noRecords": "Aucun enregistrement trouvé",
      "columns": {
        "action": "Action",
        "user": "Utilisateur",
        "resource": "Ressource",
        "details": "Détails",
        "date": "Date",
        "ip": "IP"
      },
      "changed": "Modifié",
      "actionFilters": {
        "user": "Utilisateur",
        "subscription": "Abonnement",
        "payment": "Paiement",
        "settings": "Paramètres",
        "campaign": "Campagne",
        "content": "Contenu"
      }
    },
    "settings": {
      "subtitle": "Configurer les paramètres du système",
      "saveChanges": "Enregistrer les modifications",
      "generalSettings": "Paramètres généraux",
      "supportEmail": "E-mail de support",
      "defaultPlan": "Forfait par défaut",
      "termsUrl": "URL des conditions d'utilisation",
      "privacyUrl": "URL de la politique de confidentialité",
      "userSettings": "Paramètres utilisateur",
      "maxDevices": "Appareils maximum par compte",
      "trialDays": "Jours de période d'essai",
      "maintenanceMode": "Mode maintenance",
      "maintenanceModeDesc": "Lorsqu'il est activé, le système sera inaccessible aux utilisateurs",
      "featureFlags": "Drapeaux de fonctionnalités",
      "systemActions": "Actions système",
      "clearCache": "Vider le cache",
      "resetAnalytics": "Réinitialiser les analyses",
      "actionsWarning": "Ces actions peuvent affecter les performances du système. Utilisez avec précaution.",
      "savingSuccess": "Paramètres enregistrés avec succès",
      "confirmClearCache": "Vider le cache ? Cela peut affecter temporairement les performances.",
      "cacheCleared": "Cache vidé avec succès",
      "confirmResetAnalytics": "Réinitialiser les données d'analyse ? Cette action est irréversible !",
      "analyticsReset": "Les données d'analyse ont été réinitialisées",
      "featureFlagLabels": {
        "new_player": "Nouveau lecteur",
        "live_chat": "Chat en direct",
        "downloads": "Téléchargements",
        "watch_party": "Soirée visionnage",
        "voice_search": "Recherche vocale",
        "ai_recommendations": "Recommandations IA"
      }
    },
    "content": {
      "title": "Bibliothèque de contenu",
      "subtitle": "Gérer les films, séries et contenus vidéo",
      "importFree": "Importer du contenu gratuit",
      "searchPlaceholder": "Rechercher du contenu...",
      "emptyMessage": "Aucun contenu trouvé",
      "confirmDelete": "Supprimer ce contenu ?",
      "confirmBatchDelete": "Êtes-vous sûr de vouloir supprimer {{count}} élément(s) ?",
      "selectedItems": "{{count}} élément(s) sélectionné(s)",
      "batchFeature": "Mettre en avant",
      "batchUnfeature": "Retirer de la mise en avant",
      "import": {
        "pageTitle": "Importer du contenu gratuit",
        "subtitle": "Parcourir et importer du contenu public depuis des sources gratuites",
        "selectCategory": "Sélectionnez la catégorie pour les films importés :",
        "categoryPlaceholder": "Sélectionner une catégorie...",
        "loading": "Chargement des sources...",
        "sourceTypes": {
          "vod": "Films et VOD",
          "live_tv": "TV en direct",
          "radio": "Radio",
          "podcasts": "Podcasts"
        },
        "items": "élément",
        "itemsPlural": "éléments",
        "selectItems": "Veuillez sélectionner au moins un élément à importer",
        "selectCategory_vod": "Veuillez sélectionner une catégorie pour les imports VOD",
        "importing": "Import de {{count}}... {{percent}}%",
        "importButton": "Importer {{count}} {{item}}",
        "noSources": "Aucune source disponible",
        "noSourcesDescription": "Aucune source de contenu gratuit n'est actuellement disponible pour {{type}}"
      },
      "filters": {
        "title": "Filtres",
        "contentType": "Type de contenu",
        "all": "Tout",
        "allContent": "Tout",
        "series": "Séries",
        "movies": "Films",
        "podcasts": "Podcasts",
        "radioStations": "Stations de radio",
        "status": "Statut",
        "allStatus": "Tous les statuts",
        "subtitles": "Sous-titres"
      },
      "podcastsComingSoon": "Gestion des podcasts à venir. Utilisez la section Podcasts.",
      "radioComingSoon": "Gestion des stations de radio à venir. Utilisez la section Stations de Radio.",
      "showOnlyWithSubtitles": "Afficher uniquement avec sous-titres",
      "status": {
        "published": "Publié",
        "draft": "Brouillon"
      },
      "columns": {
        "title": "Titre",
        "category": "Catégorie",
        "year": "Année",
        "status": "Statut",
        "views": "Vues",
        "rating": "Note",
        "streamUrl": "URL du flux",
        "epgSource": "Source EPG",
        "genre": "Genre",
        "episodeNumber": "N° épisode",
        "description": "Description",
        "duration": "Durée",
        "publishedDate": "Date de publication",
        "episodes": "Épisodes",
        "order": "Ordre",
        "name": "Nom",
        "slug": "Identifiant",
        "subtitles": "Sous-titres"
      },
      "validation": {
        "titleRequired": "Le titre est requis",
        "nameRequired": "Le nom est requis",
        "streamUrlRequired": "L'URL du flux est requise",
        "audioUrlRequired": "L'URL audio est requise"
      },
      "episodes_one": "épisode",
      "episodes_other": "épisodes",
      "noEpisodes": "Aucun épisode trouvé",
      "type": {
        "series": "Série",
        "movie": "Film"
      },
      "toggleCarousel": "Basculer le carrousel",
      "editor": {
        "pageTitle": "Modifier le contenu",
        "pageTitleNew": "Ajouter du contenu",
        "sections": {
          "basicInfo": "Informations de base",
          "media": "Média",
          "streaming": "Diffusion",
          "details": "Détails du contenu",
          "publishing": "Publication",
          "accessControl": "Contrôle d'accès",
          "podcastDetails": "Détails du podcast",
          "episodeDetails": "Détails de l'épisode",
          "stationDetails": "Détails de la station",
          "channelDetails": "Détails de la chaîne"
        },
        "fields": {
          "title": "Titre",
          "titlePlaceholder": "Titre du contenu",
          "titleRequired": "Le titre est requis",
          "year": "Année",
          "yearPlaceholder": "2024",
          "description": "Description",
          "descriptionPlaceholder": "Description du contenu",
          "thumbnail": "Vignette (ratio 3:4)",
          "thumbnailUrl": "URL de la vignette",
          "thumbnailUrlPlaceholder": "https://exemple.com/vignette.jpg",
          "backdrop": "Fond (ratio 16:9)",
          "backdropUrl": "URL du fond",
          "posterCover": "Couverture du podcast",
          "logo": "Logo",
          "channelLogo": "Logo de la chaîne",
          "stationLogo": "Logo de la station",
          "streamUrl": "URL du flux",
          "streamUrlRequired": "L'URL du flux est requise",
          "streamType": "Type de flux",
          "drmProtected": "Protégé par DRM",
          "drmProtectedLabel": "Ce contenu nécessite une protection DRM",
          "category": "Catégorie",
          "categoryRequired": "La catégorie est requise",
          "duration": "Durée",
          "durationPlaceholder": "1:30:00",
          "rating": "Classification",
          "ratingPlaceholder": "PG-13",
          "genre": "Genre",
          "genrePlaceholder": "Drame",
          "director": "Réalisateur",
          "directorPlaceholder": "Nom du réalisateur",
          "isSeries": "Série",
          "isSeriesLabel": "Ceci est une série/contenu multi-épisodes",
          "season": "Saison",
          "episode": "Épisode",
          "seriesId": "ID de la série",
          "seriesIdPlaceholder": "identifiant-serie",
          "isPublished": "Publier",
          "isPublishedLabel": "Publier ce contenu immédiatement",
          "isFeatured": "Mettre en avant",
          "isFeaturedLabel": "Mettre ce contenu en avant sur la page d'accueil",
          "requiresSubscription": "Abonnement requis",
          "isKidsContent": "Contenu enfants",
          "isKidsContentLabel": "Ce contenu est adapté aux enfants",
          "author": "Auteur",
          "authorPlaceholder": "Auteur du podcast",
          "podcastCategory": "Catégorie",
          "podcastCategoryPlaceholder": "Actualités, Science, etc.",
          "rssFeed": "URL du flux RSS",
          "rssFeedPlaceholder": "https://exemple.com/feed.xml",
          "website": "URL du site web",
          "websitePlaceholder": "https://exemple.com",
          "episodeNumber": "N° épisode",
          "seasonNumber": "N° saison",
          "audioUrl": "URL audio",
          "audioUrlRequired": "L'URL audio est requise",
          "audioUrlPlaceholder": "https://exemple.com/episode.mp3",
          "publishedAt": "Date de publication",
          "epgSource": "URL source EPG",
          "epgSourcePlaceholder": "https://exemple.com/epg.xml",
          "currentShow": "Émission en cours",
          "currentShowPlaceholder": "Nom de l'émission",
          "nextShow": "Émission suivante",
          "nextShowPlaceholder": "Nom de l'émission",
          "currentSong": "Chanson en cours",
          "currentSongPlaceholder": "Titre de la chanson",
          "isActive": "Actif",
          "isActiveLabel": "La chaîne est active",
          "requiredSubscription": "Abonnement requis",
          "publishedDate": "Date de publication"
        },
        "subscriptionTiers": {
          "basic": "Basique",
          "premium": "Premium",
          "family": "Famille"
        },
        "actions": {
          "save": "Enregistrer",
          "saving": "Enregistrement...",
          "cancel": "Annuler"
        },
        "imageUpload": {
          "dropHere": "Déposez l'image ici ou cliquez pour téléverser",
          "formats": "PNG, JPG, WebP jusqu'à {{maxSize}}Mo",
          "uploading": "Téléversement...",
          "success": "Image téléversée avec succès",
          "orPasteUrl": "Ou collez l'URL de l'image",
          "urlPlaceholder": "https://exemple.com/image.jpg",
          "validateButton": "Ajouter",
          "validating": "Validation...",
          "clear": "Supprimer l'image",
          "errors": {
            "imageOnly": "Veuillez sélectionner un fichier image",
            "tooLarge": "La taille du fichier doit être inférieure à {{maxSize}}Mo",
            "uploadFailed": "Échec du téléversement",
            "invalidUrl": "URL invalide"
          }
        }
      },
      "categoryPicker": {
        "selectPlaceholder": "Sélectionner une catégorie...",
        "searchPlaceholder": "Rechercher des catégories...",
        "loading": "Chargement des catégories...",
        "noResults": "Aucune catégorie trouvée",
        "noCategories": "Aucune catégorie disponible",
        "createNew": "Créer une nouvelle catégorie",
        "errors": {
          "loadFailed": "Échec du chargement des catégories",
          "createFailed": "Échec de la création de la catégorie"
        },
        "modal": {
          "title": "Créer une nouvelle catégorie",
          "placeholder": "Nom de la catégorie (ex: Films, Séries)",
          "creating": "Création...",
          "create": "Créer"
        }
      },
      "streamUrlInput": {
        "copyUrl": "Copier l'URL",
        "copied": "URL copiée dans le presse-papiers",
        "streamType": "Type de flux",
        "validUrl": "URL valide - détectée comme {{type}}",
        "errors": {
          "required": "L'URL du flux est requise",
          "invalidFormat": "Format d'URL invalide"
        },
        "supportedFormats": {
          "title": "Formats pris en charge :",
          "hls": "HLS : flux .m3u8",
          "dash": "DASH : flux .mpd",
          "audio": "Audio : .mp3, .aac ou flux audio"
        }
      }
    },
    "categories": {
      "subtitle": "Gérer les catégories de contenu",
      "emptyMessage": "Aucune catégorie trouvée",
      "status": {
        "active": "Actif",
        "inactive": "Inactif"
      },
      "form": {
        "nameHebrew": "Nom de la catégorie (Hébreu)",
        "nameEnglish": "Nom de la catégorie (Anglais)",
        "slug": "Identifiant"
      }
    },
    "liveChannels": {
      "subtitle": "Gérer les chaînes TV en direct",
      "emptyMessage": "Aucune chaîne en direct trouvée",
      "subtitleSettings": "Paramètres des sous-titres en direct",
      "form": {
        "name": "Nom de la chaîne",
        "streamUrl": "URL du flux",
        "epgSource": "URL source EPG (optionnel)",
        "currentShow": "Émission en cours",
        "order": "Ordre",
        "supportsSubtitles": "Activer les sous-titres en direct",
        "primaryLanguage": "Langue principale (Source)",
        "targetLanguages": "Langues de traduction disponibles",
        "targetLanguagesHelp": "Sélectionnez les langues vers lesquelles les utilisateurs peuvent traduire en temps réel"
      }
    },
    "radioStations": {
      "subtitle": "Gérer les stations de radio",
      "emptyMessage": "Aucune station de radio trouvée",
      "form": {
        "name": "Nom de la station",
        "genre": "Genre",
        "streamUrl": "URL du flux",
        "currentShow": "Émission en cours (optionnel)",
        "currentSong": "Chanson en cours (optionnel)",
        "order": "Ordre"
      }
    },
    "podcasts": {
      "subtitle": "Gérer les podcasts et épisodes",
      "episodesSubtitle": "Gérer les épisodes",
      "emptyMessage": "Aucun podcast trouvé",
      "noEpisodes": "Aucun épisode trouvé",
      "form": {
        "title": "Titre du podcast",
        "author": "Auteur",
        "description": "Description",
        "category": "Catégorie",
        "rssFeed": "URL du flux RSS",
        "website": "URL du site web (optionnel)"
      },
      "episodes": {
        "form": {
          "title": "Titre de l'épisode",
          "description": "Description",
          "episodeNumber": "Numéro d'épisode",
          "seasonNumber": "Numéro de saison (optionnel)",
          "duration": "Durée",
          "audioUrl": "URL audio (requis)",
          "publishedDate": "Date de publication (AAAA-MM-JJ)"
        }
      }
    },
    "users": {
      "subtitle": "Gérer les utilisateurs et les comptes",
      "addUser": "Ajouter un utilisateur",
      "status": {
        "active": "Actif",
        "inactive": "Inactif",
        "blocked": "Bloqué"
      },
      "filters": {
        "all": "Tout",
        "active": "Actif",
        "inactive": "Inactif",
        "blocked": "Bloqué"
      },
      "columns": {
        "name": "Nom",
        "role": "Rôle",
        "subscription": "Abonnement",
        "noSubscription": "Pas d'abonnement",
        "status": "Statut",
        "created": "Créé",
        "actions": "Actions"
      },
      "confirmDelete": "Supprimer l'utilisateur",
      "confirmDeleteMessage": "Êtes-vous sûr de vouloir supprimer {{name}} ? Cette action est irréversible.",
      "resetPassword": "Réinitialiser le mot de passe",
      "block": "Bloquer",
      "unban": "Débloquer",
      "confirmResetPassword": "Envoyer un e-mail de réinitialisation du mot de passe à {{email}} ?",
      "resetPasswordSent": "E-mail de réinitialisation du mot de passe envoyé",
      "recentActivity": "Activité récente",
      "noActivity": "Aucune activité",
      "notFound": "Utilisateur non trouvé",
      "backToList": "Retour à la liste",
      "banReason": "Motif du blocage",
      "banReasonPrompt": "Motif du blocage :",
      "confirmUnban": "Débloquer l'utilisateur ?",
      "userDetails": "Détails de l'utilisateur",
      "id": "ID",
      "registered": "Inscrit",
      "billingHistory": "Historique de facturation",
      "noPayments": "Aucun paiement"
    },
    "campaigns": {
      "subtitle": "Gérer les codes promo et les réductions",
      "expired": "Expiré",
      "status": {
        "active": "Actif",
        "inactive": "Inactif"
      },
      "columns": {
        "name": "Nom",
        "discount": "Réduction",
        "usage": "Utilisations",
        "validUntil": "Valide jusqu'au",
        "status": "Statut",
        "actions": "Actions"
      },
      "confirmDelete": "Supprimer la campagne",
      "confirmDeleteMessage": "Êtes-vous sûr de vouloir supprimer \"{{name}}\" ? Cette action est irréversible.",
      "searchPlaceholder": "Rechercher des campagnes...",
      "emptyMessage": "Aucune campagne trouvée",
      "deactivate": "Désactiver",
      "activate": "Activer",
      "createTitle": "Nouvelle campagne",
      "editTitle": "Modifier la campagne",
      "formSubtitle": "Configurer un code promo ou une réduction",
      "form": {
        "name": "Nom de la campagne",
        "namePlaceholder": "ex: Soldes d'été 2024",
        "code": "Code promo",
        "generate": "Générer",
        "discountType": "Type de réduction",
        "discountValue": "Valeur de la réduction",
        "maxUses": "Utilisations maximum",
        "unlimited": "Illimité",
        "validUntil": "Valide jusqu'au",
        "active": "Campagne active"
      }
    },
    "subscriptions": {
      "subtitle": "Afficher et gérer les abonnés du système",
      "status": {
        "active": "Actif",
        "paused": "En pause",
        "cancelled": "Annulé",
        "expired": "Expiré"
      },
      "columns": {
        "user": "Utilisateur",
        "plan": "Forfait",
        "price": "Prix",
        "nextBilling": "Prochaine facturation",
        "status": "Statut"
      },
      "perMonth": "/mois",
      "searchPlaceholder": "Rechercher un abonnement...",
      "emptyMessage": "Aucun abonnement trouvé",
      "actions": {
        "changePlan": "Changer de forfait",
        "pause": "Mettre en pause",
        "resume": "Reprendre",
        "cancel": "Annuler",
        "delete": "Supprimer"
      },
      "editPlan": {
        "title": "Changer de forfait d'abonnement",
        "user": "Utilisateur",
        "currentPlan": "Forfait actuel",
        "newPlan": "Sélectionner un nouveau forfait"
      },
      "addSubscription": {
        "title": "Ajouter un abonnement",
        "userEmail": "E-mail de l'utilisateur",
        "emailPlaceholder": "Entrez l'e-mail de l'utilisateur",
        "duration": "Durée (jours)",
        "selectPlan": "Sélectionner un forfait"
      },
      "fillAllFields": "Veuillez remplir tous les champs",
      "userNotFound": "Utilisateur non trouvé",
      "selectOneToEdit": "Veuillez sélectionner exactement un abonnement à modifier",
      "selectToDelete": "Veuillez sélectionner des abonnements à supprimer",
      "confirmDeleteMultiple": "Supprimer {{count}} abonnement(s) ?",
      "selected": "sélectionné(s)",
      "confirmDelete": "Êtes-vous sûr de vouloir supprimer l'abonnement de {{user}} ? Cette action est irréversible."
    },
    "marketingDashboard": {
      "subtitle": "Aperçu marketing",
      "refresh": "Actualiser",
      "totalSubscribers": "Abonnés totaux",
      "emailOpenRate": "Taux d'ouverture e-mail",
      "pushClickRate": "Taux de clic push",
      "activeSegments": "Segments actifs",
      "campaignStatus": {
        "active": "Actif",
        "completed": "Terminée",
        "scheduled": "Planifiée",
        "draft": "Brouillon"
      }
    },
    "transactions": {
      "subtitle": "Afficher l'historique des paiements",
      "exportCsv": "Exporter CSV",
      "status": {
        "completed": "Terminé",
        "pending": "En attente",
        "failed": "Échoué",
        "refunded": "Remboursé"
      },
      "columns": {
        "id": "ID",
        "user": "Utilisateur",
        "amount": "Montant",
        "type": "Type",
        "status": "Statut",
        "date": "Date"
      },
      "filters": {
        "all": "Tout"
      },
      "searchPlaceholder": "Rechercher une transaction...",
      "emptyMessage": "Aucune transaction trouvée",
      "details": "Détails de la transaction",
      "email": "E-mail"
    },
    "pushNotifications": {
      "subtitle": "Créer et envoyer des notifications aux utilisateurs",
      "newNotification": "Nouvelle notification",
      "status": {
        "draft": "Brouillon",
        "sent": "Envoyée",
        "scheduled": "Planifiée"
      },
      "columns": {
        "title": "Titre",
        "status": "Statut",
        "sent": "Envoyées",
        "opened": "Ouvertes",
        "scheduledAt": "Planifiée pour",
        "created": "Créée",
        "actions": "Actions"
      },
      "filters": {
        "all": "Tout"
      },
      "searchPlaceholder": "Rechercher une notification...",
      "emptyMessage": "Aucune notification trouvée",
      "createModal": "Nouvelle notification push",
      "editModal": "Modifier la notification",
      "scheduleModal": "Planifier la notification",
      "titleLabel": "Titre",
      "bodyLabel": "Corps",
      "dateTimeLabel": "Date et heure",
      "cancel": "Annuler",
      "create": "Créer la notification",
      "schedule": "Planifier",
      "send": "Envoyer maintenant",
      "confirmSend": "Envoyer la notification \"{{title}}\" ?",
      "confirmDelete": "Supprimer la notification \"{{title}}\" ?",
      "fillRequired": "Veuillez remplir le titre et le corps"
    }
  },
  "placeholder": {
    "email": "your@email.com",
    "password": "••••••••",
    "pin": "••••",
    "dateRange": {
      "from": "Du (AAAA-MM-JJ)",
      "to": "Au (AAAA-MM-JJ)"
    },
    "amount": {
      "min": "Min",
      "max": "Max",
      "price": "0.00"
    },
    "chatMessage": "Saisissez ici...",
    "deepLink": "bayitplus://content/123",
    "scheduleDateTime": "YYYY-MM-DDTHH:mm",
    "roomCode": "ABCD1234",
    "time": {
      "start": "08:00",
      "end": "10:00"
    },
    "filter": {
      "userId": "Entrer l'identifiant utilisateur"
    },
    "datetime": "YYYY-MM-DDTHH:mm",
    "number": "0",
    "chat": "Saisissez votre message..."
  },
  "components": {
    "select": {
      "default": "Sélectionner..."
    }
  },
  "plans": {
    "basic": {
      "name": "Basique",
      "features": [
        "Tout le contenu VOD",
        "Radio et Podcasts",
        "Regarder sur 1 appareil",
        "Qualité SD"
      ],
      "notIncluded": [
        "Chaînes en direct",
        "Assistant IA",
        "Visionnage hors ligne"
      ]
    },
    "premium": {
      "name": "Premium",
      "features": [
        "Tout le contenu VOD",
        "Chaînes en direct",
        "Radio et Podcasts",
        "Assistant IA intelligent",
        "Regarder sur 2 appareils",
        "Qualité HD"
      ],
      "notIncluded": [
        "Visionnage hors ligne",
        "Profils familiaux"
      ]
    },
    "family": {
      "name": "Famille",
      "features": [
        "Tout le contenu VOD",
        "Chaînes en direct",
        "Radio et Podcasts",
        "Assistant IA intelligent",
        "Regarder sur 4 appareils",
        "Qualité 4K",
        "5 profils familiaux",
        "Téléchargement hors ligne"
      ],
      "notIncluded": []
    },
    "batchActions": {
      "selectedCount": "{{count}} sélectionné(s)",
      "selectedCount_one": "{{count}} sélectionné",
      "selectedCount_other": "{{count}} sélectionnés",
      "clear": "Effacer"
    },
    "costDashboard": {
      "title": "Tableau des Coûts",
      "costBreakdown": "Répartition des Coûts",
      "loadingBreakdown": "Chargement de la répartition...",
      "aiCosts": "Coûts IA",
      "infrastructure": "Infrastructure",
      "thirdParty": "Tiers",
      "thirdPartyApis": "APIs Tiers",
      "translation": "Traduction",
      "search": "Recherche",
      "percentOfTotal": "% du total",
      "components": "Composants",
      "topSpenders": {
        "title": "Top 20 Utilisateurs (Mensuel)",
        "loading": "Chargement des meilleurs utilisateurs...",
        "rank": "Rang",
        "userId": "ID Utilisateur",
        "costRange": "Plage de Coûts",
        "privacyNote": "Les IDs utilisateurs sont chiffrés et les coûts sont regroupés par tranches pour protéger la vie privée."
      },
      "categories": {
        "permanent": "Permanent",
        "transient": "Variable",
        "permanentVsTransient": "Permanent vs Variable",
        "permanentFixed": "Permanent (Fixe)",
        "transientVariable": "Variable (Usage)",
        "permanentDesc": "Coûts d'infrastructure mensuels indépendants de l'utilisation",
        "transientDesc": "Coûts basés sur l'utilisation qui fluctuent avec l'activité de la plateforme",
        "detailedBreakdown": "Répartition Détaillée",
        "costItem": "Élément de Coût",
        "category": "Catégorie",
        "amount": "Montant"
      },
      "timeline": {
        "title": "Chronologie des Coûts",
        "loading": "Chargement de la chronologie...",
        "amountLabel": "Montant ($)",
        "revenue": "Revenus",
        "totalCost": "Coût Total",
        "netProfit": "Profit Net",
        "showingData": "Affichage des données de {{start}} à {{end}}"
      },
      "plSummary": {
        "netProfitLoss": "Profit/Perte Net(te)",
        "margin": "marge",
        "revenue": "REVENUS",
        "totalCosts": "COÛTS TOTAUX"
      }
    }
  },
  "subscribe": {
    "title": "Choisissez votre forfait",
    "subtitle": "7 jours d'essai gratuit pour tout forfait. Annulez à tout moment.",
    "monthly": "Mensuel",
    "yearly": "Annuel",
    "save2Months": "Économisez 2 mois",
    "popular": "Le plus populaire",
    "period": "/mois",
    "perYear": "/an",
    "select": "Sélectionner le forfait",
    "selected": "Sélectionné",
    "processing": "Traitement...",
    "startTrial": "Commencer l'essai gratuit",
    "noCharge": "Votre carte de crédit ne sera pas débitée pendant la période d'essai"
  },
  "notFound": {
    "title": "Page introuvable",
    "description": "La page que vous recherchez n'existe pas ou a été déplacée.",
    "homeButton": "Accueil",
    "searchButton": "Rechercher",
    "orTry": "Ou essayez :",
    "liveChannel": "En direct",
    "vodLabel": "Films",
    "podcastsLabel": "Podcasts"
  },
  "profiles": {
    "addProfile": "Ajouter un profil",
    "enterPin": "Entrer le PIN",
    "selectError": "Erreur lors de la sélection du profil",
    "wrongPin": "PIN incorrect",
    "loading": "Chargement des profils...",
    "manage": "Gérer les profils",
    "whoIsWatching": "Qui regarde ?",
    "manageProfiles": "Gérer les profils",
    "kids": "Enfants",
    "addIcon": "+"
  },
  "watch": {
    "notFound": "Contenu introuvable",
    "backToHome": "Retour à l'accueil",
    "episodes": "Épisodes",
    "addToList": "Ajouter à la liste",
    "like": "J'aime",
    "share": "Partager",
    "cast": "Distribution",
    "episodesList": "Épisodes",
    "schedule": "Programme",
    "now": "Now",
    "related": "Contenu associé",
    "deleteEpisode": "Supprimer l'épisode",
    "confirmDeleteEpisode": "Supprimer cet épisode ?"
  },
  "live": {
    "title": "TV en direct",
    "next": "Suivant :",
    "noChannels": "Aucune chaîne disponible",
    "tryLater": "Réessayez plus tard",
    "categories": {
      "all": "All",
      "news": "Actualités",
      "entertainment": "Divertissement",
      "sports": "Sports",
      "kids": "Enfants",
      "music": "Musique"
    }
  },
  "judaism": {
    "title": "Judaïsme",
    "items": "éléments",
    "empty": "Aucun contenu disponible",
    "emptyHint": "Essayez de sélectionner une autre catégorie",
    "dashboard": "Votre tableau de bord juif",
    "categories": {
      "news": "Actualités juives",
      "community": "Communauté"
    },
    "shabbat": {
      "title": "Horaires du Shabbat",
      "shabbatShalom": "Shabbat Shalom !",
      "shabbatMode": "Mode Shabbat",
      "endsIn": "Le Shabbat se termine dans",
      "candleLighting": "Allumage des bougies",
      "havdalah": "Havdalah",
      "parashat": "Parashat",
      "friday": "Vendredi",
      "saturday": "Samedi",
      "noData": "Impossible de charger les horaires du Shabbat"
    },
    "erevShabbat": {
      "title": "Veille de Chabbat",
      "prepareFor": "Préparer le Chabbat",
      "inTime": "dans {{time}}",
      "featuredContent": "Contenu du Chabbat",
      "noContent": "Contenu du Chabbat bientôt disponible !",
      "shabbatShalom": "Chabbat Chalom !",
      "timeUntil": "Temps avant le Chabbat",
      "shabbatSongs": "Chants de Chabbat",
      "parashaStudy": "Parasha",
      "shabbatRecipes": "Recettes",
      "prayers": "Prières"
    }
  },
  "children": {
    "title": "Enfants",
    "items": "éléments",
    "empty": "Aucun contenu disponible",
    "emptyHint": "Essayez une autre catégorie",
    "exitKidsMode": "Quitter le mode enfants",
    "exitDescription": "Entrez le code parental pour quitter",
    "parentCode": "Code parental",
    "confirm": "Confirmer",
    "wrongCode": "Code incorrect",
    "noContent": "Aucun contenu disponible",
    "tryAnotherCategory": "Essayez de sélectionner une autre catégorie",
    "categories": {
      "all": "Tout",
      "cartoons": "Dessins animés",
      "educational": "Éducatif",
      "music": "Musique",
      "hebrew": "Hébreu",
      "stories": "Histoires",
      "jewish": "Juif"
    },
    "ageRatings": {
      "3": "3 ans et plus",
      "5": "5 ans et plus",
      "7": "7 ans et plus",
      "10": "10 ans et plus",
      "12": "12 ans et plus"
    },
    "moderation": {
      "pending": "En attente d'examen",
      "approved": "Approuvé",
      "rejected": "Rejeté"
    },
    "admin": {
      "stats": "Gestionnaire de contenu enfants",
      "seedContent": "Contenu initial",
      "importArchive": "Importer depuis Archive.org",
      "syncPodcasts": "Synchroniser les podcasts",
      "syncYouTube": "Synchroniser YouTube",
      "tagVod": "Tagger VOD",
      "pendingModeration": "En attente de modération"
    }
  },
  "youngsters": {
    "title": "Jeunes",
    "items": "éléments",
    "empty": "Aucun contenu disponible",
    "emptyHint": "Essayez une autre catégorie",
    "exitYoungstersMode": "Quitter le mode jeunes",
    "exitDescription": "Entrez le code parental pour quitter",
    "parentCode": "Code parental",
    "confirm": "Confirmer",
    "wrongCode": "Code incorrect",
    "noContent": "Aucun contenu disponible",
    "tryAnotherCategory": "Essayez de sélectionner une autre catégorie",
    "categories": {
      "all": "All",
      "trending": "Tendances",
      "news": "Actualités",
      "culture": "Culture",
      "educational": "Éducatif",
      "music": "Musique",
      "entertainment": "Divertissement",
      "sports": "Sports",
      "tech": "Technologie",
      "judaism": "Judaïsme"
    },
    "ageGroups": {
      "middle-school": "Collège (12-14)",
      "high-school": "Lycée (15-17)"
    },
    "moderation": {
      "pending": "En attente d'examen",
      "approved": "Approuvé",
      "rejected": "Rejeté"
    },
    "admin": {
      "stats": "Gestionnaire de contenu jeunes",
      "seedContent": "Contenu initial",
      "importArchive": "Importer depuis Archive.org",
      "syncPodcasts": "Synchroniser les podcasts",
      "syncYouTube": "Synchroniser YouTube",
      "tagVod": "Tagger VOD",
      "pendingModeration": "En attente de modération"
    }
  },
  "chatbot": {
    "title": "Assistant Bayit+",
    "greeting": "Bonjour ! Je suis l'assistant intelligent Bayit+. Comment puis-je vous aider aujourd'hui ? Cliquez sur le microphone et parlez, ou tapez un message.",
    "openChat": "Ouvrir le chat",
    "welcome": "Bonjour ! Je suis l'assistant intelligent Bayit+. Comment puis-je vous aider aujourd'hui ? Cliquez sur le microphone et parlez, ou tapez un message.",
    "placeholder": "Tapez ici...",
    "recording": "Enregistrement... cliquez à nouveau pour arrêter",
    "transcribing": "Transcription...",
    "stopRecording": "Arrêter l'enregistrement",
    "startRecording": "Commencer l'enregistrement vocal",
    "recommendations": "Voici quelques recommandations :",
    "showMultipleSuccess": "Affichage de {{count}} éléments de contenu dans les widgets",
    "showMultipleNotFound": "Impossible de trouver le contenu demandé. Veuillez essayer d'autres noms.",
    "resolvingContent": "Recherche de votre contenu...",
    "errors": {
      "micPermission": "Impossible d'accéder au microphone. Veuillez vérifier les autorisations du microphone dans votre navigateur.",
      "transcribeFailed": "Impossible de transcrire l'enregistrement. Veuillez réessayer.",
      "general": "Désolé, un problème est survenu. Veuillez réessayer."
    },
    "suggestions": {
      "whatToWatch": "Que regarder aujourd'hui ?",
      "israeliMovies": "Films israéliens recommandés",
      "whatsOnNow": "Qu'est-ce qui passe maintenant ?",
      "popularPodcasts": "Podcasts populaires"
    },
    "voiceCommands": {
      "showChannels": "Montrez-moi les chaînes...",
      "playChess": "Commencer une partie d'échecs avec...",
      "multiContent": "Afficher côte à côte..."
    }
  },
  "chat": {
    "title": "Assistant Bayit+",
    "greeting": "Bonjour ! Je suis l'assistant intelligent Bayit+. Comment puis-je vous aider aujourd'hui ? Cliquez sur le microphone et parlez, ou saisissez un message."
  },
  "subtitles": {
    "nikud": "Nikoud",
    "selection": "Sélection",
    "translation": "Traduction",
    "translating": "Traduction en cours...",
    "close": "Fermer",
    "unavailable": "Traduction indisponible",
    "off": "Désactivé",
    "none": "Aucun",
    "autoGenerated": "Généré automatiquement",
    "selectLanguage": "Sélectionner la langue des sous-titres",
    "liveTranslate": "Traduction en direct",
    "translateTo": "Traduire vers",
    "downloadMore": "Télécharger plus de sous-titres...",
    "downloading": "Recherche sur OpenSubtitles...",
    "opensubtitlesSource": "Depuis OpenSubtitles.com",
    "downloadSuccess": "{{count}} sous-titre(s) téléchargé(s)",
    "noSubtitlesFound": "Aucun sous-titre trouvé pour ce contenu",
    "smartSubs": "Sous-titres intelligents",
    "smartSubsDescription": "Double affichage : Hébreu simplifié + Anglais avec mise en évidence des racines",
    "smartSubsDualView": "Double affichage",
    "shoreshToggle": "Mise en évidence des racines",
    "shoreshOn": "Mise en évidence Shoresh activée",
    "shoreshOff": "Mise en évidence Shoresh désactivée",
    "nikudLive": "Hébreu avec Nikud",
    "nikudLiveDescription": "Sous-titres hébraïques vocalisés avec signes diacritiques pour une lecture facilitée",
    "nikudEnabled": "Sous-titres Nikud activés",
    "nikudDisabled": "Sous-titres Nikud désactivés",
    "nikudSubtitleLabel": "Hébreu avec nikud : {{text}}",
    "available": "Sous-titres",
    "clickToEnable": "Cliquez pour activer la traduction en direct",
    "connectionError": "Erreur de traduction en direct",
    "inputLanguageTooltip": "Vérifier la langue source",
    "premiumRequired": "Abonnement Premium requis",
    "selectInputLanguage": "Sélectionner la langue source",
    "translateActive": "Traduction en direct active",
    "noEnglishSubtitles": "Aucun sous-titre anglais disponible pour ce contenu.",
    "hebrewMode": {
      "title": "Mode d'affichage hébreu",
      "unavailable": "Indisponible",
      "generate": "Générer",
      "regular": {
        "title": "Hébreu standard",
        "description": "Texte hébreu standard sans voyelles"
      },
      "nikud": {
        "title": "Hébreu avec Nikud",
        "description": "Hébreu vocalisé avec voyelles pour une lecture facilitée",
        "unavailableReason": "Traitement IA non disponible pour ce contenu"
      },
      "shoresh": {
        "title": "Shoresh (Racines)",
        "description": "Mots hébraïques avec analyse des racines : mot [racine]",
        "unavailableReason": "Analyse des racines non disponible pour ce contenu"
      }
    },
    "englishMode": {
      "title": "Mode d'affichage anglais",
      "unavailable": "Indisponible",
      "generate": "Générer",
      "firstTimeHint": "Ces modes alimentés par l'IA vous aident à maintenir l'hébreu tout en apprenant la structure des phrases anglaises. Chaque mode offre une expérience d'apprentissage unique.",
      "regular": {
        "title": "Anglais standard",
        "description": "Sous-titres anglais standard"
      },
      "heblish": {
        "title": "Heblish",
        "description": "Anglais avec insertions de mots hébraïques pour un apprentissage immersif",
        "unavailableReason": "Traitement Heblish non disponible pour ce contenu"
      },
      "grammarFlip": {
        "title": "Grammar-Flip",
        "description": "Mots hébraïques avec structure de phrase anglaise (Sujet-Verbe-Objet)",
        "unavailableReason": "Traitement Grammar-Flip non disponible pour ce contenu"
      },
      "slangSynthesis": {
        "title": "Synthèse d'argot",
        "description": "Mélange d'argot israélien et américain moderne pour un contenu engageant",
        "unavailableReason": "Traitement Slang Synthesis non disponible pour ce contenu"
      }
    },
    "loading": "Chargement des sous-titres...",
    "error": {
      "title": "Erreur de sous-titres",
      "retry": "Réessayer",
      "loadFailed": "Échec du chargement des sous-titres",
      "cuesFailed": "Échec du chargement du texte des sous-titres",
      "networkError": "Erreur réseau - veuillez vérifier votre connexion",
      "serverError": "Erreur serveur - veuillez réessayer plus tard"
    },
    "aiModesAvailable": "Modes IA disponibles",
    "aiModesTitle": "Modes de sous-titres IA",
    "fetchSubtitles": "Récupérer les sous-titres",
    "fontSize": "Taille de police",
    "mode": {
      "engrew": "Engrew",
      "heblish": "Heblish",
      "shoresh": "Shoresh",
      "standard": "Standard"
    },
    "opensubtitles": "OpenSubtitles",
    "searchExternal": "Rechercher des sous-titres externes",
    "settingsTitle": "Paramètres des sous-titres",
    "showBackground": "Afficher l'arrière-plan",
    "singleMode": "Mode unique",
    "splitMode": "Mode divisé",
    "primary_language": "Langue Principale",
    "secondary_language": "Langue Secondaire",
    "layout_mode": "Mode de disposition",
    "interactive_title": "Sous-titres Interactifs"
  },
  "video": {
    "watchTrailer": "Voir la bande-annonce",
    "closeTrailer": "Fermer la bande-annonce",
    "deleteConfirm": "Supprimer cet épisode ?"
  },
  "recordings": {
    "title": "Mes enregistrements",
    "subtitle": "Consultez et gérez vos enregistrements de diffusions en direct",
    "record": "Enregistrer",
    "recording": "Enregistrement",
    "storageUsed": "Stockage utilisé",
    "totalRecordings": "Total des enregistrements",
    "maxDuration": "Durée maximale",
    "noRecordings": "Aucun enregistrement",
    "noRecordingsHint": "Commencez à enregistrer depuis n'importe quelle chaîne en direct !",
    "confirmDelete": "Êtes-vous sûr de vouloir supprimer cet enregistrement ? Cette action est irréversible.",
    "deleteRecording": "Supprimer l'enregistrement",
    "deleteFailed": "Échec de la suppression de l'enregistrement",
    "expires": "Expire",
    "subtitlesAvailable": "Sous-titres disponibles",
    "recordingSaved": "Enregistrement sauvegardé !",
    "savedSuccess": "Enregistrement sauvegardé avec succès ! Durée : {{duration}}",
    "viewInMyRecordings": "Voir dans mes enregistrements",
    "error": "Erreur d'enregistrement",
    "startFailed": "Échec du démarrage de l'enregistrement. Veuillez réessayer.",
    "stopFailed": "Échec de l'arrêt de l'enregistrement. Veuillez réessayer.",
    "page": "Page"
  },
  "chess": {
    "title": "Échecs",
    "welcome": "Bienvenue aux échecs",
    "subtitle": "Jouez aux échecs avec vos amis et votre famille dans le monde entier",
    "createGame": "Créer une nouvelle partie",
    "joinGame": "Rejoindre la partie",
    "gameCode": "Code de jeu",
    "enterGameCode": "Entrer le code de jeu",
    "invalidGameCode": "Code de jeu invalide. Doit contenir 6 caractères.",
    "joinFailed": "Échec de la connexion au jeu",
    "join": "Rejoindre",
    "create": "Créer",
    "chooseColor": "Choisissez votre couleur",
    "white": "Blanc",
    "black": "Noir",
    "chatPlaceholder": "Saisissez un message... (@bot pour des conseils)",
    "botHint": "Mentionnez @bot dans votre message pour obtenir des conseils d'échecs de notre assistant IA",
    "bot": "Assistant d'échecs",
    "mute": "Couper le son",
    "unmute": "Réactiver le son",
    "speaking": "participants",
    "resign": "Abandonner",
    "offerDraw": "Proposer un match nul",
    "newGame": "Nouvelle partie",
    "checkmate": "Échec et mat !",
    "stalemate": "Pat",
    "draw": "Match nul",
    "resigned": "Partie abandonnée",
    "reconnecting": "Reconnexion...",
    "moveHistory": "Historique des coups",
    "noMoves": "Aucun coup joué",
    "showHints": "Afficher les astuces du guide",
    "yourTurn": "Votre tour",
    "opponentTurn": "Tour de l'adversaire",
    "waitingForOpponent": "En attente de l'adversaire...",
    "gameOver": "Fin de partie",
    "sendingInvite": "Envoi de l'invitation à {{name}}...",
    "inviteSent": "Invitation envoyée à {{name}} ! Code : {{code}}",
    "inviteFailed": "Impossible de trouver cet utilisateur. Veuillez vérifier le nom et réessayer.",
    "inviteReceived": "{{name}} vous a invité à une partie d'échecs !",
    "joinInvite": "Rejoindre la partie",
    "challenge": "Défi",
    "playedAsWhite": "Joué avec les blancs",
    "playedAsBlack": "Joué avec les noirs",
    "gameMode": "Mode de jeu",
    "playVsFriend": "Jouer contre un ami",
    "playVsBot": "Jouer contre le bot",
    "difficulty": "Difficulté",
    "easy": "Facile",
    "medium": "Moyen",
    "hard": "Difficile",
    "chessBot": "Robot d'échecs",
    "chat": {
      "title": "Discussion",
      "inputPlaceholder": "Saisissez un message..."
    },
    "acceptDraw": "Accepter le match nul",
    "acceptInvite": "Accepter l'invitation",
    "blackCaptured": "Noir capturé",
    "blackTurn": "Tour des noirs",
    "challengeFriend": "Défier un ami",
    "challengeViaWhatsApp": "Défier via WhatsApp",
    "copyCode": "Copier le code",
    "declineDraw": "Refuser le match nul",
    "declineInvite": "Refuser l'invitation",
    "drawOffered": "Match nul proposé",
    "joinByGameCode": "Rejoindre par code",
    "noFriendsYet": "Pas encore d'amis",
    "offline": "Hors ligne",
    "online": "En ligne",
    "opponent": "Adversaire",
    "whiteCaptured": "Blanc capturé",
    "whiteTurn": "Tour des blancs",
    "you": "You"
  },
  "friends": {
    "title": "Amis et adversaires",
    "subtitle": "Connectez-vous avec des joueurs et défiez vos amis",
    "myFriends": "Mes amis",
    "requests": "Demandes",
    "findPlayers": "Trouver des joueurs",
    "friendsLabel": "Amis",
    "pendingLabel": "En attente",
    "add": "Ajouter un ami",
    "remove": "Supprimer",
    "accept": "Accepter",
    "reject": "Rejeter",
    "cancel": "Annuler",
    "noFriends": "Pas encore d'amis",
    "noFriendsDesc": "Recherchez des joueurs et envoyez des demandes d'ami",
    "lastGame": "Dernière partie : {{time}}",
    "friendsSince": "Amis depuis {{date}}",
    "incomingRequests": "Demandes reçues",
    "outgoingRequests": "Demandes envoyées",
    "noIncoming": "Aucune demande reçue",
    "noOutgoing": "Aucune demande envoyée",
    "sentAt": "Envoyé {{time}}",
    "searchPlaceholder": "Rechercher par nom...",
    "noResults": "Aucun joueur trouvé",
    "noResultsDesc": "Essayez de chercher avec un autre nom",
    "requestSent": "Demande d'ami envoyée !",
    "requestAccepted": "Demande d'ami acceptée !",
    "requestRejected": "Demande d'ami rejetée",
    "requestCancelled": "Demande d'ami annulée",
    "friendRemoved": "Ami supprimé",
    "searchFailed": "Échec de la recherche d'utilisateurs",
    "requestFailed": "Échec de l'envoi de la demande",
    "acceptFailed": "Échec de l'acceptation de la demande",
    "rejectFailed": "Échec du rejet de la demande",
    "cancelFailed": "Échec de l'annulation de la demande",
    "removeFailed": "Échec de la suppression de l'ami",
    "friendsCount": "{{count}} amis",
    "gamesCount": "{{count}} parties",
    "alreadyFriends": "Amis"
  },
  "stats": {
    "statistics": "Statistiques",
    "matchHistory": "Historique des matchs",
    "headToHead": "Face à face",
    "gamesPlayed": "Parties jouées",
    "wins": "Victoires",
    "losses": "Défaites",
    "draws": "Matchs nuls",
    "winRate": "Taux de victoire",
    "rating": "Classement",
    "peakRating": "Classement maximum",
    "peak": "Maximum",
    "winStreak": "Série de victoires",
    "currentStreak": "Série actuelle",
    "bestStreak": "Meilleure série",
    "performance": "Performance",
    "achievements": "Réalisations",
    "currentRating": "Classement actuel",
    "totalGames": "Total des parties",
    "noGames": "Aucune partie jouée",
    "moves": "coups",
    "won": "Won",
    "lost": "Perdu",
    "draw": "Match nul",
    "overall": "Bilan général",
    "yourWins": "Vos victoires",
    "theirWins": "Leurs victoires",
    "totalGamesPlayed": "Total : {{count}} parties",
    "recentGames": "Parties récentes"
  },
  "support": {
    "title": "Centre d'aide",
    "subtitle": "Comment pouvons-nous vous aider aujourd'hui ?",
    "tabs": {
      "docs": "Documentation",
      "faq": "FAQ",
      "contact": "Contact",
      "tickets": "Mes tickets"
    },
    "categories": {
      "title": "Parcourir la documentation",
      "loading": "Chargement de la documentation...",
      "loadError": "Échec du chargement des catégories",
      "articleCount": "{{count}} articles",
      "gettingStarted": "Pour commencer",
      "features": "Fonctionnalités",
      "troubleshooting": "Dépannage",
      "account": "Compte"
    },
    "docs": {
      "loading": "Chargement du document...",
      "loadError": "Échec du chargement du document",
      "backToList": "Retour à la documentation"
    },
    "search": {
      "placeholder": "Rechercher dans la documentation...",
      "noResults": "Aucun résultat trouvé"
    },
    "faq": {
      "title": "Questions fréquentes",
      "loading": "Chargement de la FAQ...",
      "loadError": "Échec du chargement de la FAQ",
      "empty": "Aucune question dans cette catégorie",
      "categories": {
        "all": "Tous les sujets",
        "general": "Général",
        "billing": "Facturation",
        "technical": "Technique",
        "features": "Fonctionnalités"
      }
    },
    "contact": {
      "voiceTitle": "Support vocal",
      "voiceDescription": "Cliquez sur le bouton avatar ou dites \"Jarvis\" pour démarrer une conversation vocale avec notre assistant IA.",
      "ticketTitle": "Créer un ticket de support",
      "ticketDescription": "Besoin d'aide humaine ? Créez un ticket de support et notre équipe répondra dans les 24 heures.",
      "createTicket": "Créer un ticket",
      "emailTitle": "Support par e-mail",
      "emailDescription": "Vous préférez l'e-mail ? Contactez-nous à support@bayit.tv pour toute question ou préoccupation."
    },
    "ticket": {
      "title": "Créer un ticket de support",
      "subject": "Sujet",
      "subjectPlaceholder": "Brève description de votre problème",
      "message": "Message",
      "messagePlaceholder": "Décrivez votre problème en détail...",
      "categoryLabel": "Catégorie",
      "priorityLabel": "Priorité",
      "submit": "Soumettre le ticket",
      "category": {
        "billing": "Facturation",
        "technical": "Technique",
        "feature": "Demande de fonctionnalité",
        "general": "Général"
      },
      "priority": {
        "low": "Low",
        "medium": "Moyen",
        "high": "Élevé",
        "urgent": "Urgent"
      },
      "status": {
        "open": "Ouvert",
        "in_progress": "En cours",
        "resolved": "Résolu",
        "closed": "Fermé"
      },
      "created": "Créé",
      "error": {
        "required": "Veuillez remplir tous les champs obligatoires",
        "submit": "Échec de la création du ticket. Veuillez réessayer."
      }
    },
    "tickets": {
      "title": "Mes tickets de support",
      "loading": "Chargement des tickets...",
      "loadError": "Échec du chargement des tickets",
      "empty": "Aucun ticket de support",
      "emptyFilter": "Aucun ticket avec ce statut",
      "create": "Nouveau ticket",
      "createFirst": "Créez votre premier ticket",
      "filter": {
        "all": "All",
        "open": "Ouvert",
        "inProgress": "En cours",
        "resolved": "Résolu"
      }
    },
    "voice": {
      "title": "Assistant vocal",
      "listening": "J'écoute...",
      "thinking": "Laissez-moi réfléchir...",
      "speaking": "Parle...",
      "error": "Désolé, je n'ai pas compris. Réessayer ?",
      "ready": "Que souhaitez-vous savoir ?",
      "listeningNow": "Écoute en cours...",
      "wakeWordHint": "Dites « Jarvis » pour parler"
    },
    "wizard": {
      "role": "Votre guide"
    }
  },
  "jerusalem": {
    "title": "Connexion Jérusalem",
    "subtitle": "Restez connecté au coeur d'Israël",
    "noContent": "Aucun contenu sur Jérusalem disponible",
    "sources": "Sources",
    "kotelLive": "Mur occidental en direct",
    "categories": {
      "kotel": "Mur occidental",
      "idf-ceremony": "Cérémonies de Tsahal",
      "diaspora-connection": "Connexion diaspora",
      "holy-sites": "Lieux saints",
      "jerusalem-events": "Événements à Jérusalem",
      "general": "Jérusalem"
    }
  },
  "telAviv": {
    "title": "Connexion Tel-Aviv",
    "subtitle": "La ville qui ne s'arrête jamais",
    "noContent": "Aucun contenu sur Tel-Aviv disponible",
    "sources": "Sources",
    "beachLive": "Webcam plage",
    "categories": {
      "beaches": "Plages",
      "nightlife": "Vie nocturne",
      "culture": "Culture et art",
      "music": "Scène musicale",
      "food": "Cuisine et restauration",
      "tech": "Tech et startups",
      "events": "Événements",
      "general": "Tel-Aviv"
    }
  },
  "voiceOnboarding": {
    "welcome": {
      "title": "Bienvenue dans le controle vocal",
      "description": "Controlez Bayit+ avec votre voix pour une experience mains libres."
    },
    "features": {
      "voiceCommands": "Commandes Vocales",
      "voiceCommandsDesc": "Naviguez, recherchez et contrôlez la lecture avec la parole naturelle",
      "tts": "Synthèse Vocale",
      "ttsDesc": "Écoutez les réponses et descriptions de contenu à haute voix",
      "wakeWord": "Mot d'Activation",
      "wakeWordDesc": "Dites 'Bayit' pour activer le contrôle vocal à tout moment"
    },
    "getStarted": "Commencer",
    "permissions": {
      "title": "Accès au Microphone",
      "description": "Le contrôle vocal nécessite l'accès au microphone pour entendre vos commandes",
      "privacy": "Vos données vocales sont traitées de manière sécurisée et ne sont jamais stockées"
    },
    "permissionsGranted": "Accès au microphone accordé",
    "permissionRequired": {
      "title": "Permission Requise",
      "message": "Veuillez activer l'accès au microphone dans les paramètres de votre appareil pour utiliser le contrôle vocal"
    },
    "grantPermissions": "Accorder les Permissions",
    "testWakeWord": {
      "title": "Tester le Mot d'Activation",
      "description": "Dites 'Bayit' pour tester l'activation vocale",
      "success": "Parfait ! L'activation vocale fonctionne"
    },
    "startTest": "Démarrer le Test",
    "complete": {
      "title": "Tout est Prêt !",
      "description": "Le contrôle vocal est maintenant activé. Essayez ces commandes :",
      "tryCommands": "Essayez Ces Commandes",
      "examples": {
        "search": "\"Rechercher Fauda\"",
        "play": "\"Lire les actualités\"",
        "navigate": "\"Aller à la TV en Direct\"",
        "control": "\"Pause\" ou \"Augmenter le volume\""
      },
      "startUsing": "Commencer à Utiliser le Contrôle Vocal"
    },
    "skip": "Passer pour l'instant",
    "buttons": {
      "back": "Retour"
    },
    "completion": {
      "message": "Les fonctionnalites vocales sont pretes.",
      "title": "Configuration vocale terminee"
    },
    "title": "Configuration vocale",
    "training": {
      "message": "Lisez les phrases a haute voix pour entrainer la reconnaissance.",
      "title": "Entrainement vocal"
    }
  },
  "taxonomy": {
    "sections": {
      "movies": "Films",
      "series": "Séries",
      "kids": "Enfants",
      "youngsters": "Jeunes",
      "music": "Musique",
      "documentaries": "Documentaires",
      "podcasts": "Podcasts",
      "live": "TV en direct"
    },
    "subcategories": {
      "learning-hebrew": "Apprendre l'hébreu",
      "young-science": "Jeune science",
      "math-fun": "Mathématiques ludiques",
      "nature-animals": "Nature et animaux",
      "interactive": "Interactif",
      "hebrew-songs": "Chansons hébraïques",
      "nursery-rhymes": "Comptines",
      "kids-movies": "Films pour enfants",
      "kids-series": "Séries pour enfants",
      "jewish-holidays": "Fêtes juives",
      "torah-stories": "Histoires de la Torah",
      "bedtime-stories": "Histoires du soir",
      "tiktok-trends": "Tendances TikTok",
      "viral-videos": "Vidéos virales",
      "memes": "Mèmes",
      "israel-news": "Actualités d'Israël",
      "world-news": "Actualités mondiales",
      "science-news": "Actualités scientifiques",
      "sports-news": "Actualités sportives",
      "music-culture": "Culture musicale",
      "film-culture": "Culture cinématographique",
      "art-culture": "Culture artistique",
      "food-culture": "Culture culinaire",
      "study-help": "Aide aux études",
      "career-prep": "Préparation professionnelle",
      "life-skills": "Compétences de vie",
      "teen-movies": "Films pour ados",
      "teen-series": "Séries pour ados",
      "gaming": "Jeux",
      "coding": "Programmation",
      "gadgets": "Gadgets",
      "bar-bat-mitzvah": "Bar/Bat Mitsvah",
      "teen-torah": "Torah pour ados",
      "jewish-history": "Histoire juive",
      "learning-hebrew.description": "Apprendre a lire, ecrire et le vocabulaire en hebreu pour les enfants",
      "young-science.description": "Experiences et explications scientifiques adaptees aux enfants",
      "math-fun.description": "Apprendre les nombres et l'arithmetique de maniere ludique",
      "nature-animals.description": "Le monde des animaux et de la nature pour les enfants curieux",
      "interactive.description": "Contenu interactif et participatif pour les enfants",
      "hebrew-songs.description": "Chansons israeliennes classiques et nouvelles pour enfants",
      "nursery-rhymes.description": "Chansons et melodies pour les tout-petits et les bebes",
      "kids-movies.description": "Films complets adaptes aux enfants",
      "kids-series.description": "Series animees et emissions pour enfants",
      "jewish-holidays.description": "Contenu sur les fetes juives et les traditions pour les enfants",
      "torah-stories.description": "Histoires de la Torah et de la tradition juive",
      "bedtime-stories.description": "Histoires relaxantes pour l'heure du coucher",
      "tiktok-trends.description": "Tendances et defis populaires sur TikTok",
      "viral-videos.description": "Videos virales populaires sur les reseaux sociaux",
      "memes.description": "Memes amusants et culture internet",
      "israel-news.description": "Actualites d'Israel adaptees aux adolescents",
      "world-news.description": "Actualites internationales pour les jeunes",
      "science-news.description": "Decouvertes scientifiques et innovation technologique",
      "sports-news.description": "Mises a jour sportives et resultats des matchs",
      "music-culture.description": "Scene musicale, artistes et festivals",
      "film-culture.description": "Cinema, series et critiques",
      "art-culture.description": "Art, galeries et creativite",
      "food-culture.description": "Cuisine, recettes et culture culinaire",
      "study-help.description": "Aide aux examens, resumes et preparation aux tests",
      "career-prep.description": "Preparation a l'universite et a la carriere",
      "life-skills.description": "Competences de vie, gestion financiere et autonomie",
      "teen-movies.description": "Films recommandes pour les adolescents",
      "teen-series.description": "Series populaires pour les adolescents",
      "gaming.description": "Jeux video, e-sport et gaming",
      "coding.description": "Programmation, codage et developpement logiciel",
      "gadgets.description": "Gadgets, technologie et critiques",
      "bar-bat-mitzvah.description": "Preparation et celebrations de Bar/Bat Mitzvah",
      "teen-torah.description": "Cours de Torah et paracha de la semaine pour ados",
      "jewish-history.description": "Histoire du peuple juif"
    }
  },
  "passkey": {
    "manager": {
      "title": "Clés d'accès",
      "subtitle": "Gérez vos clés d'accès pour un accès sécurisé au contenu"
    },
    "unsupported": "Les clés d'accès ne sont pas prises en charge sur cet appareil",
    "fetchError": "Échec du chargement des clés d'accès",
    "registerError": "Échec de l'enregistrement de la clé d'accès",
    "deleteError": "Échec de la suppression de la clé d'accès",
    "cancelled": "L'opération de clé d'accès a été annulée",
    "noPasskeys": "Aucune clé d'accès enregistrée. Ajoutez-en une pour débloquer le contenu privé.",
    "unknownDevice": "Appareil inconnu",
    "created": "Créé",
    "lastUsed": "Dernière utilisation",
    "never": "Jamais",
    "addPasskey": "Ajouter une clé d'accès",
    "deleteConfirmTitle": "Supprimer la clé d'accès ?",
    "deleteConfirmText": "Cette clé d'accès ne pourra plus déverrouiller le contenu. Vous pourrez toujours l'ajouter à nouveau plus tard.",
    "unlock": "Déverrouiller",
    "unlockContent": "Déverrouiller le contenu privé",
    "unlockDescription": "Utilisez votre clé d'accès pour accéder aux films et séries privés",
    "auth": {
      "title": "Déverrouiller le contenu",
      "description": "Utilisez votre empreinte digitale, votre visage ou le PIN de votre appareil pour déverrouiller les films et séries privés.",
      "unlock": "Déverrouiller avec une clé d'accès",
      "authenticating": "Authentification...",
      "success": "Contenu débloqué !",
      "cancelled": "L'authentification a été annulée",
      "error": "L'authentification a échoué. Veuillez réessayer."
    },
    "qr": {
      "useQR": "Utiliser le téléphone pour déverrouiller",
      "scanWithPhone": "Scanner avec votre téléphone",
      "instruction": "Ouvrez l'appareil photo de votre téléphone et scannez le code QR pour vous authentifier",
      "error": "Échec de la génération du code QR",
      "expired": "Le code QR a expiré. Veuillez réessayer."
    }
  },
  "olorin": {
    "errors": {
      "session_not_found": "Session introuvable",
      "session_different_partner": "La session appartient à un autre partenaire",
      "session_invalid_status": "La session est {status}, impossible d'ajouter la transcription",
      "max_sessions_reached": "Nombre maximum de sessions simultanées ({limit}) atteint",
      "invalid_api_key": "Clé API invalide",
      "missing_api_key": "En-tête {header} manquant",
      "capability_disabled": "La fonctionnalité '{capability}' est actuellement désactivée",
      "capability_not_enabled": "La fonctionnalité '{capability}' n'est pas activée pour ce partenaire",
      "source_language_not_supported": "Langue source '{language}' non prise en charge. Supportées : {supported}",
      "target_language_not_supported": "Langue cible '{language}' non prise en charge. Supportées : {supported}",
      "partner_not_found": "Partenaire introuvable",
      "partner_registration_failed": "Échec de l'enregistrement du partenaire",
      "no_updates_provided": "Aucune mise à jour fournie",
      "webhook_config_failed": "Échec de la configuration du webhook",
      "webhook_url_not_configured": "URL du webhook non configurée",
      "webhook_secret_not_configured": "Secret du webhook non configuré",
      "search_failed": "Échec de la recherche",
      "indexing_failed": "Échec de l'indexation",
      "detection_failed": "Échec de la détection",
      "explanation_failed": "Échec de l'obtention de l'explication",
      "reference_not_found": "Référence '{reference_id}' introuvable",
      "enrichment_failed": "Échec de l'enrichissement",
      "get_references_failed": "Échec de l'obtention des références",
      "create_session_failed": "Échec de la création de la session",
      "add_transcript_failed": "Échec de l'ajout de la transcription",
      "generate_recap_failed": "Échec de la génération du résumé"
    }
  },
  "portal": {
    "nav": {
      "home": "Accueil",
      "features": "Fonctionnalités",
      "solutions": "Solutions",
      "pricing": "Tarification",
      "demo": "Démo en Direct",
      "contact": "Contact",
      "getStarted": "Commencer"
    },
    "hero": {
      "ctaExplore": "Explorer les Fonctionnalités",
      "ctaDemo": "Demander une Démo"
    },
    "cta": {
      "title": "Prêt à Commencer?",
      "subtitle": "Discutons de la façon dont nous pouvons aider à transformer votre entreprise",
      "button": "Nous Contacter"
    },
    "contactPage": {
      "title": "Nous Contacter",
      "subtitle": "Intéressé par nos solutions? Parlons-en",
      "formTitle": "Envoyez-nous un Message",
      "infoTitle": "Informations de Contact",
      "form": {
        "name": "Nom Complet",
        "email": "Adresse E-mail",
        "company": "Nom de l'Entreprise",
        "phone": "Numéro de Téléphone",
        "message": "Votre Message",
        "messagePlaceholder": "Parlez-nous de vos besoins..."
      },
      "submit": "Envoyer le Message",
      "sending": "Envoi en cours...",
      "success": "Message envoyé avec succès! Nous vous recontacterons bientôt.",
      "error": "Échec de l'envoi du message. Veuillez réessayer.",
      "scheduleTitle": "Vous Préférez Planifier un Appel?",
      "scheduleSubtitle": "Réservez une démo personnalisée avec notre équipe",
      "scheduleCta": "Planifier un Appel de Démo"
    },
    "pricingPage": {
      "title": "Abordable",
      "titleHighlight": "Plans Tarifaires",
      "subtitle": "Choisissez le plan qui correspond à vos besoins",
      "comparisonTitle": "Comparaison des Fonctionnalités",
      "faqTitle": "Questions Fréquemment Posées",
      "faq": {
        "q1": "Comment est calculée la tarification?",
        "a1": "La tarification est basée sur vos besoins spécifiques et votre utilisation. Contactez-nous pour un devis personnalisé.",
        "q2": "Puis-je mettre à niveau mon plan plus tard?",
        "a2": "Oui, vous pouvez mettre à niveau à tout moment. Nous vous aiderons à migrer vos données en douceur.",
        "q3": "Quel support est inclus?",
        "a3": "Tous les plans incluent un support par e-mail. Les plans Professional et Enterprise incluent un support prioritaire avec des gestionnaires de compte dédiés."
      },
      "professional": {
        "name": "Professionnel",
        "price": "Contactez pour un Devis",
        "priceNote": "Tarification personnalisée",
        "description": "Pour les entreprises en croissance avec des besoins avancés",
        "cta": "Obtenir un Devis"
      },
      "enterprise": {
        "name": "Entreprise",
        "price": "Personnalisé",
        "priceNote": "Basé sur le volume",
        "description": "Pour les grandes organisations et les déploiements d'entreprise",
        "cta": "Contacter les Ventes"
      },
      "ctaTitle": "Prêt à Commencer?",
      "ctaSubtitle": "Discutons de vos besoins et trouvons le plan parfait",
      "ctaButton": "Contacter les Ventes"
    },
    "featuresPage": {
      "title": "Puissantes",
      "titleHighlight": "Fonctionnalités",
      "subtitle": "Tout ce dont vous avez besoin pour réussir",
      "techSpecsTitle": "Spécifications Techniques",
      "workflowTitle": "Comment ça Marche",
      "workflow": {
        "s1": {
          "title": "Importer",
          "description": "Téléchargez et organisez votre contenu"
        },
        "s2": {
          "title": "Configurer",
          "description": "Définissez vos préférences et paramètres"
        },
        "s3": {
          "title": "Déployer",
          "description": "Mettez en ligne votre solution"
        },
        "s4": {
          "title": "Surveiller",
          "description": "Suivez les performances et optimisez"
        }
      },
      "ctaTitle": "Prêt à Explorer les Fonctionnalités?",
      "ctaSubtitle": "Voyez toutes les fonctionnalités en action avec une démo personnalisée",
      "ctaButton": "Planifier une Démo"
    },
    "demoPage": {
      "title": "Découvrez Notre",
      "titleHighlight": "Plateforme",
      "subtitle": "Expérimentez la puissance de notre solution",
      "scheduleCta": "Planifier une Démo en Direct",
      "stepsTitle": "Comment ça Marche",
      "steps": {
        "analyze": {
          "title": "Analyser",
          "description": "Suivez et améliorez les performances"
        }
      },
      "featuresTitle": "Points Forts de la Plateforme",
      "platformsTitle": "Disponible Sur",
      "ctaTitle": "Prêt pour Votre Démo Personnalisée?",
      "ctaSubtitle": "Planifiez une démonstration personnalisée adaptée à vos besoins",
      "ctaButton": "Planifier une Démo"
    },
    "workflow": {
      "sectionTitle": "Flux de Travail Intelligent",
      "sectionSubtitle": "Processus rationalisé en 4 étapes",
      "step1": {
        "title": "Configurer",
        "description": "Configurez votre compte et vos préférences"
      },
      "step2": {
        "title": "Personnaliser",
        "description": "Personnalisez les paramètres selon vos besoins"
      },
      "step3": {
        "title": "Déployer",
        "description": "Lancez votre solution"
      },
      "step4": {
        "title": "Surveiller",
        "description": "Suivez les performances et optimisez"
      }
    }
  },
  "trivia": {
    "didYouKnow": "Le Saviez-Vous?",
    "dismissHint": "Fermer l'anecdote",
    "settings": {
      "displayLanguages": "Langues d'Affichage",
      "languageHint": "Sélectionnez 1-3 langues à afficher pour chaque fait",
      "language": "langue",
      "selectLanguage": "Sélectionner cette langue",
      "deselectLanguage": "Désélectionner cette langue",
      "enableDescription": "Afficher des questions trivia pendant le visionnage.",
      "enableTrivia": "Activer le trivia",
      "title": "Parametres trivia"
    },
    "aiTrivia": "Anecdotes IA",
    "tellMeMore": "En savoir plus",
    "more": "Plus",
    "follow_up": "Suivi"
  },
  "auth": {
    "loginRequired": "Connexion requise",
    "loginToWatch": "Veuillez vous connecter pour regarder {{title}}",
    "login": "Connexion",
    "signUp": "S'inscrire",
    "biometricEnrollEnable": "Activer",
    "biometricEnrollMessage": "Utilisez Face ID ou l'empreinte pour vous connecter plus vite.",
    "biometricEnrollSkip": "Passer",
    "biometricEnrollTitle": "Activer la connexion biometrique",
    "biometricSignIn": "Se connecter avec la biometrie",
    "signOut": "Se deconnecter",
    "register": {
      "createAccount": "Creer un compte",
      "email": "E-mail",
      "password": "Mot de passe",
      "confirmPassword": "Confirmer le mot de passe",
      "register": "S'inscrire",
      "alreadyHaveAccount": "Vous avez deja un compte ? Se connecter",
      "passwordStrength": {
        "weak": "Faible",
        "medium": "Moyen",
        "strong": "Fort"
      }
    }
  },
  "recording": {
    "stop": "Arrêter l'Enregistrement",
    "start": "Démarrer l'Enregistrement"
  },
  "discover": {
    "title": "Découvrir",
    "subtitle": "Explorez 19 fonctionnalités propulsées par l'IA",
    "description": "Bayit+ utilise l'intelligence artificielle pour améliorer votre expérience de visionnage, d'écoute et d'apprentissage. Découvrez ce qui est disponible sur votre plateforme.",
    "featureCount": "{{count}} fonctionnalités",
    "tryIt": "Essayer",
    "startWalkthrough": "Commencer la visite",
    "availableOn": "Disponible sur",
    "prerequisites": "Prérequis",
    "setup": "Configurer",
    "error": {
      "fetchFailed": "Échec du chargement des fonctionnalités Discover. Veuillez réessayer.",
      "unknownFeature": "Fonctionnalité introuvable.",
      "featureDisabled": "Cette fonctionnalité est actuellement désactivée."
    },
    "availability": {
      "ready": "Prêt",
      "setupNeeded": "Configuration requise",
      "premiumRequired": "Abonnement Premium requis",
      "notAvailable": "Non disponible",
      "platformOnly": "Autre plateforme"
    },
    "platform": {
      "web": "Web",
      "ios": "iOS",
      "android": "Android",
      "tvos": "Apple TV"
    },
    "category": {
      "watching_movies": "Regarder des films",
      "watching_live_tv": "Regarder la TV en direct",
      "learn_hebrew": "Apprendre l'hébreu",
      "search_discovery": "Recherche et découverte",
      "chat_assistants": "Assistants de conversation"
    },
    "feature": {
      "pause_ask": {
        "name": "Pause et Question",
        "tagline": "Mettez en pause n'importe quelle scène et interrogez votre compagnon IA",
        "description": "Pendant le visionnage, mettez le vidéo en pause et posez des questions sur la scène en cours. Votre personnage IA expliquera les références culturelles, traduira les dialogues ou discutera de l'intrigue."
      },
      "interactive_subtitles": {
        "name": "Sous-titres interactifs",
        "tagline": "Appuyez sur n'importe quel mot des sous-titres pour une traduction et un contexte instantanés",
        "description": "Cliquez sur n'importe quel mot dans les sous-titres pour voir sa traduction, entendre sa prononciation et obtenir des exemples d'utilisation. Enrichissez votre vocabulaire en regardant vos émissions préférées."
      },
      "vocabulary": {
        "name": "Constructeur de vocabulaire",
        "tagline": "Apprenez de nouveaux mots à travers les émissions que vous regardez",
        "description": "Collectez automatiquement de nouveaux mots hébreux dans les sous-titres. Révisez avec des fiches, suivez vos progrès et enrichissez votre vocabulaire grâce aux contenus que vous appréciez."
      },
      "vod_moments": {
        "name": "Moments VOD",
        "tagline": "Les meilleurs moments de vos contenus favoris sélectionnés par l'IA",
        "description": "Obtenez des extraits et moments clés générés par l'IA à partir de films et d'émissions. Partagez des scènes mémorables et revisitez les meilleurs passages."
      },
      "cultural_context": {
        "name": "Contexte culturel",
        "tagline": "Comprenez le contexte culturel derrière chaque scène",
        "description": "Recevez des annotations culturelles en temps réel expliquant les coutumes israéliennes, les fêtes, l'humour et les normes sociales qui apparaissent dans le contenu que vous regardez."
      },
      "bilingual_bridge": {
        "name": "Pont bilingue",
        "tagline": "Apprentissage hébreu-français en parallèle pendant le visionnage",
        "description": "Affichez des sous-titres en deux langues avec du vocabulaire mis en évidence. Basculez entre l'hébreu et votre langue maternelle pour développer votre compréhension naturellement."
      },
      "ai_companion": {
        "name": "Compagnon IA",
        "tagline": "Votre guide IA personnel pour le contenu israélien",
        "description": "Un personnage IA qui regarde avec vous, offrant des commentaires, répondant à vos questions et vous aidant à comprendre les nuances des médias israéliens."
      },
      "live_dubbing": {
        "name": "Doublage en direct",
        "tagline": "Doublage IA en temps réel des chaînes de TV israéliennes en direct",
        "description": "Regardez la TV israélienne en direct avec un doublage en temps réel propulsé par l'IA dans votre langue préférée. Profitez des informations, des talk-shows et du divertissement sans barrière linguistique."
      },
      "live_subtitles": {
        "name": "Sous-titres en direct",
        "tagline": "Sous-titres IA en temps réel pour les diffusions en direct",
        "description": "Obtenez des sous-titres générés par l'IA en temps réel pendant que vous regardez la TV israélienne en direct. Choisissez votre langue préférée pour une traduction instantanée du contenu en direct."
      },
      "live_trivia": {
        "name": "Trivia en direct",
        "tagline": "Jouez à des jeux de trivia basés sur ce qui est diffusé en direct",
        "description": "L'IA détecte les sujets des diffusions en direct et génère des questions de trivia en temps réel. Rivalisez avec des amis et apprenez la culture israélienne en regardant la TV."
      },
      "catch_up": {
        "name": "Rattrapage",
        "tagline": "Résumés IA de ce que vous avez manqué à la TV en direct",
        "description": "Vous avez manqué une partie d'une diffusion en direct ? Obtenez des résumés générés par l'IA qui vous remettent au courant, avec les moments clés mis en évidence pour une révision rapide."
      },
      "scene_search": {
        "name": "Recherche de scènes",
        "tagline": "Recherchez des scènes spécifiques dans tout le contenu",
        "description": "Décrivez une scène dont vous vous souvenez et l'IA la retrouvera dans tout le contenu disponible. Recherchez par dialogue, éléments visuels ou descriptions de l'intrigue."
      },
      "phonetic_mirror": {
        "name": "Miroir phonétique",
        "tagline": "Pratiquez la prononciation hébraïque avec les retours de l'IA",
        "description": "Enregistrez-vous en train de parler hébreu et recevez un retour instantané de l'IA sur votre prononciation. Comparez votre discours avec des locuteurs natifs et suivez vos progrès au fil du temps."
      },
      "talk_back": {
        "name": "Répondre",
        "tagline": "Ayez des conversations vocales en hébreu avec votre personnage IA",
        "description": "Pratiquez l'hébreu conversationnel en discutant avec votre personnage IA. Recevez des retours en temps réel sur la grammaire, le vocabulaire et la prononciation dans un dialogue naturel."
      },
      "interactive_mission": {
        "name": "Missions interactives",
        "tagline": "Des défis d'apprentissage de l'hébreu amusants avec les conseils de l'IA",
        "description": "Accomplissez des missions guidées par l'IA qui combinent le visionnage de contenu avec des exercices d'apprentissage de l'hébreu. Gagnez des récompenses et suivez votre parcours linguistique."
      },
      "glossary": {
        "name": "Glossaire personnel",
        "tagline": "Votre dictionnaire hébreu personnalisé construit à partir du contenu",
        "description": "Tous les mots hébreux que vous avez rencontrés et enregistrés, organisés par catégorie, fréquence et niveau de maîtrise. Révisez et pratiquez à tout moment."
      },
      "llm_search": {
        "name": "Recherche IA",
        "tagline": "Trouvez du contenu avec des requêtes en langage naturel",
        "description": "Recherchez dans toute la bibliothèque Bayit+ en langage naturel. Demandez des 'comédies israéliennes drôles sur la famille' ou des 'documentaires sur Tel Aviv' et obtenez des résultats sélectionnés par l'IA."
      },
      "proactive_voice": {
        "name": "Voix proactive",
        "tagline": "Assistant IA vocal qui anticipe vos besoins",
        "description": "Un assistant IA qui écoute et propose de manière proactive des suggestions de contenu pertinentes, des traductions et des opportunités d'apprentissage en fonction de ce que vous regardez."
      },
      "chatbot": {
        "name": "Discussion Bayit",
        "tagline": "Discutez avec l'IA de tout ce qui concerne le contenu israélien",
        "description": "Posez des questions sur la culture israélienne, obtenez des recommandations de contenu, pratiquez l'hébreu ou discutez de ce que vous avez regardé. Votre compagnon IA est toujours disponible."
      }
    },
    "prereq": {
      "avatar": "Créez votre personnage IA",
      "subscription": "Abonnement Premium requis",
      "microphone": "Accès au microphone requis",
      "contentType": "Sélectionnez vos préférences de contenu",
      "preference": "Définissez vos préférences linguistiques",
      "voiceClone": "Configurez votre clone vocal"
    },
    "walkthrough": {
      "tryItNow": "Essayer maintenant",
      "watchDemo": "Voir la demo",
      "skip": "Passer",
      "next": "Suivant",
      "done": "Termine",
      "complete": "Tutoriel termine",
      "stepCounter": "{{current}} sur {{total}}",
      "pause_ask": {
        "step1": "Accedez a un film avec des moments interactifs",
        "step2": "Mettez le film en pause pendant une scene",
        "step3": "Appuyez sur le bouton Demander au personnage",
        "step4": "Regardez le personnage vous repondre"
      },
      "interactive_subtitles": {
        "step1": "Lancez un film avec des sous-titres",
        "step2": "Appuyez sur le bouton Interactif dans la barre de controle",
        "step3": "Selectionnez votre langue de sous-titres",
        "step4": "Appuyez sur un mot dans les sous-titres pour en savoir plus"
      },
      "vocabulary": {
        "step1": "Ouvrez un film avec les sous-titres interactifs actives",
        "step2": "Appuyez sur un mot que vous voulez apprendre",
        "step3": "Appuyez sur Enregistrer dans le vocabulaire",
        "step4": "Consultez vos mots enregistres dans la section Vocabulaire"
      },
      "vod_moments": {
        "step1": "Regardez un film avec des moments interactifs",
        "step2": "Attendez qu'une invite interactive apparaisse",
        "step3": "Decouvrez l'interaction generee par l'IA"
      },
      "cultural_context": {
        "step1": "Lancez un film avec des dialogues en hebreu",
        "step2": "Appuyez sur un sous-titre culturellement significatif",
        "step3": "Lisez l'explication culturelle generee par l'IA"
      },
      "bilingual_bridge": {
        "step1": "Ouvrez un film avec support bilingue",
        "step2": "Selectionnez le mode sous-titres bilingue",
        "step3": "Appuyez sur une phrase en surbrillance pour voir la traduction",
        "step4": "Regardez les deux langues cote a cote"
      },
      "ai_companion": {
        "step1": "Lancez n'importe quel film",
        "step2": "Appuyez sur le bouton Compagnon IA",
        "step3": "Tapez une question sur le film",
        "step4": "Lisez la reponse contextuelle de l'IA"
      },
      "live_dubbing": {
        "step1": "Accedez a une chaine TV en direct",
        "step2": "Appuyez sur le bouton de doublage",
        "step3": "Selectionnez votre langue preferee",
        "step4": "Ecoutez le doublage IA en temps reel"
      },
      "live_subtitles": {
        "step1": "Accedez a une chaine TV en direct",
        "step2": "Appuyez sur le bouton des sous-titres",
        "step3": "Selectionnez votre langue de sous-titres",
        "step4": "Regardez les sous-titres en temps reel"
      },
      "live_trivia": {
        "step1": "Accedez a une chaine TV en direct",
        "step2": "Appuyez sur le bouton trivia",
        "step3": "Repondez aux questions generees par l'IA"
      },
      "catch_up": {
        "step1": "Accedez a une emission en direct",
        "step2": "Selectionnez l'option de rattrapage",
        "step3": "Appuyez pour generer un resume IA",
        "step4": "Lisez le resume de ce que vous avez manque"
      },
      "scene_search": {
        "step1": "Accedez a une emission enregistree",
        "step2": "Tapez ce que vous cherchez",
        "step3": "Appuyez sur la scene correspondante",
        "step4": "Regardez la scene a partir de ce point"
      },
      "phonetic_mirror": {
        "step1": "Ouvrez le Miroir Phonetique dans Zeh Ani",
        "step2": "Lisez la phrase en hebreu affichee",
        "step3": "Prononcez la phrase dans votre micro",
        "step4": "Consultez les commentaires de prononciation de l'IA"
      },
      "talk_back": {
        "step1": "Ouvrez Talk Back dans Zeh Ani",
        "step2": "Ecoutez votre avatar parler hebreu",
        "step3": "Repondez en hebreu avec votre micro",
        "step4": "Consultez les commentaires de l'IA"
      },
      "interactive_mission": {
        "step1": "Ouvrez les Missions Interactives",
        "step2": "Selectionnez un niveau de mission",
        "step3": "Suivez les exercices guides par l'IA",
        "step4": "Completez la mission et gagnez des recompenses"
      },
      "glossary": {
        "step1": "Ouvrez le Glossaire Hebreu",
        "step2": "Recherchez un mot en hebreu",
        "step3": "Ecoutez la prononciation"
      },
      "llm_search": {
        "step1": "Ouvrez l'onglet Recherche",
        "step2": "Tapez une requete en langage naturel",
        "step3": "Parcourez les resultats selectionnes par l'IA"
      },
      "proactive_voice": {
        "step1": "Ouvrez la fonction Suggestions Vocales",
        "step2": "Appuyez et maintenez pour parler",
        "step3": "Ecoutez les recommandations personnalisees"
      },
      "chatbot": {
        "step1": "Ouvrez l'Assistant IA",
        "step2": "Tapez votre question ou demande",
        "step3": "Lisez la reponse de l'IA"
      }
    }
  },
  "byoc": {
    "home": {
      "title": "Apportez votre propre contenu",
      "subtitle": "Connectez vos sources IPTV, Plex ou YouTube et profitez des fonctions IA de Bayit+ sur votre propre contenu",
      "connectButton": "Connecter des sources",
      "aiFeatures": {
        "dubbing": "Doublage IA disponible",
        "subtitles": "Sous-titres en direct disponibles"
      }
    },
    "pageSubtitle": "Apportez votre propre contenu - ajoutez des sources IPTV et de streaming",
    "addSource": "Ajouter une source",
    "sync": "Synchroniser",
    "remove": "Supprimer",
    "channelCount": "{{count}} chaînes",
    "empty": {
      "title": "Aucune source ajoutée",
      "subtitle": "Ajoutez vos sources IPTV, Xtream ou de streaming pour regarder votre propre contenu aux côtés de Bayit+"
    },
    "source": {
      "iptv": "Source IPTV",
      "xtream": "Xtream Codes"
    },
    "sourceType": {
      "iptv": "IPTV / M3U",
      "xtream": "Xtream Codes"
    },
    "addIptv": {
      "title": "Ajouter une source IPTV",
      "subtitle": "Entrez une URL vers un fichier de playlist M3U ou M3U8",
      "urlPlaceholder": "https://example.com/playlist.m3u",
      "validate": "Valider",
      "add": "Ajouter la source"
    },
    "addXtream": {
      "title": "Connecter Xtream Codes",
      "subtitle": "Entrez les identifiants de votre serveur Xtream Codes",
      "serverUrl": "URL du serveur",
      "username": "Nom d'utilisateur",
      "password": "Mot de passe",
      "connect": "Connecter"
    },
    "preview": {
      "title": "Aperçu",
      "channelCount": "{{count}} chaînes trouvées"
    },
    "providers": {
      "title": "Fournisseurs populaires"
    },
    "wizard": {
      "step1": "Ajouter une source",
      "step2": "Traitement",
      "step3": "Révision",
      "selectSource": "Sélectionner le type de source"
    },
    "normalization": {
      "title": "Traitement de votre contenu",
      "total": "{{count}} chaînes au total",
      "matched": "{{count}} correspondances",
      "stage": {
        "parsing": "Analyse de la playlist...",
        "matching": "Correspondance des chaînes...",
        "enriching": "Enrichissement des métadonnées...",
        "finalizing": "Finalisation..."
      }
    },
    "review": {
      "title": "Réviser le contenu importé",
      "subtitle": "{{matched}} correspondances, {{unmatched}} chaînes sans correspondance",
      "matchedChannels": "Chaînes correspondantes",
      "unmatchedChannels": "Chaînes sans correspondance",
      "apply": "Appliquer et importer"
    },
    "error": {
      "urlRequired": "Veuillez entrer une URL",
      "noChannels": "Aucune chaîne trouvée dans cette playlist",
      "invalidUrl": "Impossible de charger la playlist depuis cette URL",
      "allFieldsRequired": "Tous les champs sont obligatoires",
      "enrichFailed": "Échec de l'analyse de la source",
      "syncFailed": "Échec de la synchronisation de la source",
      "normalizationFailed": "Le traitement du contenu a échoué",
      "normalizationPollFailed": "Connexion perdue pendant le traitement"
    },
    "plex": {
      "connectPlex": "Connecter Plex",
      "enterCodeAt": "Entrez ce code sur",
      "waitingForAuth": "En attente d'autorisation...",
      "selectServer": "Selectionnez un serveur Plex",
      "connecting": "Connexion a {{serverName}}...",
      "connected": "Connecte",
      "label": "Plex"
    },
    "settings": {
      "title": "Vos sources de contenu",
      "refresh": "Actualiser",
      "noSources": "Aucune source de contenu connectee",
      "noSourcesSubtitle": "Connectez votre Plex, YouTube, IPTV ou fournisseur Xtream",
      "removeSource": "Supprimer la source",
      "plexSubtitle": "Diffusez depuis votre serveur multimedia Plex",
      "youtubeSubtitle": "Accedez a votre bibliotheque YouTube",
      "iptvXtreamLabel": "IPTV / Xtream",
      "iptvXtreamSubtitle": "Ajoutez une liste M3U ou des codes Xtream",
      "youtube": "YouTube",
      "xtreamCodes": "Xtream Codes",
      "iptv": "IPTV"
    }
  },
  "onboarding": {
    "welcome": {
      "title": "Bienvenue sur Bayit+",
      "subtitle": "Votre portail alimenté par IA vers le contenu israélien, la culture et l'apprentissage des langues",
      "getStarted": "Commencer"
    },
    "highlight": {
      "dubbing": "Doublage IA en direct",
      "subtitles": "Sous-titres interactifs",
      "ai": "Compagnons IA",
      "learning": "Apprentissage de l'hébreu"
    },
    "voice": {
      "title": "Configuration vocale",
      "subtitle": "Activez votre microphone pour les commandes vocales, la pratique de la prononciation en hébreu et la navigation mains libres",
      "enable": "Activer le microphone",
      "granted": "Microphone activé avec succès"
    },
    "tour": {
      "done": "Terminé"
    },
    "demo": {
      "dubbing": {
        "title": "Doublage IA en direct",
        "description": "Regardez la télévision israélienne avec un doublage IA en temps réel dans votre langue préférée",
        "hebrew": "Hébreu",
        "english": "Anglais"
      },
      "subtitles": {
        "title": "Sous-titres interactifs",
        "description": "Appuyez sur n'importe quel mot dans les sous-titres pour une traduction et une prononciation instantanées",
        "sample": "La famille s'est réunie pour le dîner de Shabbat",
        "word": "Chabbat",
        "translation": "Sabbat - jour de repos hebdomadaire"
      },
      "interaction": {
        "title": "Interaction avec un personnage IA",
        "description": "Mettez en pause n'importe quelle scène et demandez à votre compagnon IA le contexte culturel",
        "userMsg": "Quelle fête célèbrent-ils ?",
        "aiMsg": "Ils célèbrent Sukkot, la Fête des Tabernacles. La hutte temporaire que vous voyez s'appelle une soukka."
      },
      "trivia": {
        "title": "Quiz en direct",
        "description": "L'IA génère des questions de quiz à partir de ce qui est diffusé en direct. Participez et apprenez !",
        "question": "Quelle est la langue officielle d'Israël ?",
        "optionA": "Arabe",
        "optionB": "Hébreu",
        "optionC": "Anglais"
      },
      "catchup": {
        "title": "Rattrapage intelligent",
        "description": "Vous avez manqué une partie d'une diffusion en direct ? L'IA résume ce que vous avez manqué",
        "missed": "Manqué",
        "summary": "Résumé IA",
        "live": "En direct"
      },
      "byoc": {
        "title": "Apportez votre propre contenu",
        "description": "Importez vos sources IPTV et regardez-les aux côtés du contenu Bayit+",
        "step1": "Ajouter une source",
        "step2": "Enrichissement IA",
        "step3": "Regarder"
      },
      "zehAni": {
        "title": "Créez votre personnage IA",
        "description": "Générez un avatar IA personnalisé qui apprend avec vous",
        "generated": "Avatar IA"
      }
    }
  },
  "dm": {
    "title": "Messages",
    "conversations": "Conversations",
    "conversation": "Conversation",
    "empty": {
      "title": "Aucun message pour l'instant",
      "subtitle": "Commencez une conversation avec un ami"
    },
    "input": {
      "placeholder": "Écrivez un message...",
      "send": "Envoyer"
    },
    "translate": "Traduire",
    "react": "Réagir",
    "read": "Lu",
    "sent": "Envoyé",
    "loadMore": "Charger les messages précédents",
    "startConversation": "Envoyez un message pour démarrer la conversation",
    "reaction": {
      "like": "J'aime",
      "love": "Adore",
      "laugh": "Haha",
      "surprise": "Wow",
      "sad": "Triste"
    },
    "error": {
      "fetchFailed": "Impossible de charger les messages",
      "sendFailed": "Impossible d'envoyer le message"
    }
  },
  "household": {
    "empty": {
      "title": "Aucun foyer pour l'instant",
      "subtitle": "Créez un foyer pour gérer votre famille"
    },
    "create": {
      "namePlaceholder": "Nom du foyer",
      "button": "Créer un foyer"
    },
    "members": "Membres",
    "role": {
      "owner": "Propriétaire",
      "guardian": "Tuteur",
      "child": "Enfant"
    },
    "invite": {
      "title": "Inviter des membres",
      "emailPlaceholder": "Adresse e-mail",
      "send": "Envoyer l'invitation",
      "pending": "Invitations en attente"
    },
    "removeMember": "Retirer",
    "error": {
      "fetchFailed": "Échec du chargement du foyer",
      "createFailed": "Échec de la création du foyer",
      "updateFailed": "Échec de la mise à jour du foyer",
      "deleteFailed": "Échec de la suppression du foyer",
      "inviteFailed": "Échec de l'envoi de l'invitation",
      "removeFailed": "Échec de la suppression du membre"
    }
  },
  "aiChat": {
    "retryButton": "Reessayer",
    "sendButton": "Envoyer",
    "title": "Chat IA",
    "voiceButton": "Voix"
  },
  "aiOnboarding": {
    "buttons": {
      "back": "Retour"
    },
    "completion": {
      "message": "C'est pret ! Commencez a explorer les fonctionnalites IA.",
      "title": "Configuration terminee"
    },
    "permissions": {
      "description": "Accordez les autorisations pour activer les fonctionnalites IA comme la voix et la camera.",
      "title": "Autorisations"
    },
    "personalization": {
      "description": "Indiquez vos preferences pour personnaliser votre experience IA.",
      "title": "Personnalisation"
    },
    "title": "Configuration IA",
    "welcome": {
      "description": "Bayit+ utilise l'IA pour ameliorer votre experience avec le doublage, les sous-titres et plus.",
      "title": "Bienvenue dans Bayit+ IA"
    }
  },
  "auth_device_authorized": "Appareil autorise",
  "auth_device_code_expired": "Code expire",
  "auth_device_get_new_code": "Obtenir un nouveau code",
  "auth_device_manual_login": "Se connecter manuellement",
  "auth_device_visit_uri": "Visitez l'URL affichee sur votre TV",
  "avatar": {
    "tapToSpeak": "Appuyez pour parler",
    "title": "Avatar"
  },
  "dubbing": {
    "mixer": {
      "dubbedAudio": "Audio double",
      "originalAudio": "Audio original",
      "title": "Mixeur audio"
    },
    "settings_title": "Parametres de doublage",
    "target_language": "Langue cible",
    "voiceSelector": {
      "selected": "Selectionne",
      "subtitle": "Choisissez une voix pour le doublage",
      "title": "Selection de voix"
    }
  },
  "go_back": "Retour",
  "miniPlayer": {
    "closePlayer": "Fermer le lecteur",
    "skipBackward": "Reculer",
    "skipForward": "Avancer"
  },
  "retry": "Reessayer",
  "search_hint": "Rechercher chaines, films, series...",
  "search_no_results": "Aucun resultat trouve",
  "search_prompt": "Que cherchez-vous ?",
  "subscription_required": "Abonnement requis",
  "subscription_upsell_tv": "Mettez a niveau pour regarder sur TV",
  "talkback": {
    "title": "Retour vocal"
  },
  "voiceAssistant": {
    "fabLabel": "Assistant vocal",
    "modal": {
      "cancel": "Annuler",
      "setupMessage": "Configurez la reconnaissance vocale pour utiliser l'assistant.",
      "setupRequired": "Configuration requise",
      "startSetup": "Demarrer la configuration",
      "title": "Assistant vocal"
    }
  },
  "voiceCommand": {
    "executing": "Execution...",
    "listening": "Ecoute...",
    "noMatch": "Aucune correspondance",
    "recognized": "Reconnu"
  },
  "voiceDecision": {
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "matched": "Correspondance"
  },
  "voiceSearch": {
    "listening": "Ecoute...",
    "noResults": "Aucun resultat",
    "tapToSpeak": "Appuyez pour parler",
    "title": "Recherche vocale"
  },
  "voiceSettings": {
    "language": "Langue",
    "speechRate": "Vitesse de parole",
    "title": "Parametres vocaux",
    "ttsProvider": "Fournisseur TTS",
    "voiceMode": "Mode vocal",
    "voiceSelection": "Selection de voix",
    "wakeWord": "Mot d'activation"
  },
  "voiceWizard": {
    "buttons": {
      "back": "Retour"
    },
    "calibration": {
      "description": "Parlez normalement pour calibrer le microphone.",
      "listening": "Ecoute...",
      "micButton": "Demarrer l'enregistrement",
      "resultTitle": "Resultat de calibration",
      "stopButton": "Arreter l'enregistrement",
      "tapToStart": "Appuyez pour commencer la calibration",
      "title": "Calibration du microphone"
    },
    "complete": {
      "message": "La configuration de l'assistant vocal est terminee.",
      "title": "Configuration terminee"
    },
    "language": {
      "description": "Selectionnez votre langue preferee pour les commandes vocales.",
      "title": "Langue vocale"
    },
    "permission": {
      "description": "L'acces au microphone est necessaire pour les fonctionnalites vocales.",
      "granted": "Autorisation accordee",
      "requestButton": "Accorder l'autorisation",
      "title": "Autorisation du microphone"
    },
    "title": "Assistant de configuration vocale"
  },
  "watch_now": "Regarder maintenant",
  "culture": {
    "title": "Culture israélienne",
    "description": "Jérusalem, Tel-Aviv et patrimoine israélien",
    "shabbat": {
      "title": "Mode Chabbat",
      "enableShabbatMode": "Activer le mode Chabbat",
      "shabbatTimes": "Horaires du Chabbat",
      "timesDescription": "Les horaires d'allumage des bougies et de Havdalah seront affichés ici",
      "aboutTitle": "À propos du mode Chabbat",
      "aboutDescription": "Lorsqu'il est activé, le mode Chabbat mettra en pause les notifications, réduira la luminosité de l'écran et activera une interface simplifiée pendant les heures du Chabbat."
    },
    "judaism": {
      "holidaysAndTorah": "Fêtes et Torah",
      "parashaOfTheWeek": "Parasha de la semaine",
      "parashaDescription": "Lecture hebdomadaire de la Torah et commentaire"
    },
    "morning": {
      "title": "Rituel du matin",
      "description": "Commencez votre journée avec intention et gratitude",
      "dailyInspiration": "Inspiration quotidienne",
      "dailyInspirationDescription": "Contenu sélectionné pour votre routine matinale",
      "modehAni": "Modé Ani",
      "modehAniDescription": "Prière de gratitude du matin",
      "netilatYadayim": "Netilat Yadayim",
      "netilatYadayimDescription": "Lavage rituel des mains",
      "shacharit": "Cha'harit",
      "shacharitDescription": "Service de prière du matin"
    },
    "glossary": {
      "termDetail": "Détail du terme",
      "definition": "Définition",
      "pronunciation": "Prononciation",
      "examples": "Exemples"
    },
    "jerusalem": {
      "title": "Jérusalem"
    },
    "telaviv": {
      "title": "Tel-Aviv"
    }
  },
  "zehAni": {
    "dashboard": {
      "title": "Zeh Ani",
      "biometricConsent": "Consentement biométrique",
      "activeConsents": "{{count}} consentements actifs",
      "magicMirror": "Miroir magique",
      "magicMirrorDescription": "Salutations quotidiennes et identification faciale",
      "v2vPractice": "Pratique V2V",
      "v2vPracticeDescription": "Prononciation voix-à-voix",
      "avatar3d": "Avatar 3D",
      "avatar3dDescription": "Votre maillage d'avatar personnalisé",
      "movieInteractions": "Interactions avec les films",
      "movieInteractionsDescription": "Parcourez et discutez avec les personnages de films",
      "contacts": "Contacts",
      "contactsDescription": "Partage de contacts WhatsApp",
      "feedback": "Commentaires",
      "feedbackDescription": "Partagez votre expérience",
      "consent": "Consentement",
      "consentDescription": "Gestion du consentement biométrique",
      "chess": "Échecs",
      "chessDescription": "Jouez aux échecs avec vos amis et votre famille"
    },
    "mirror": {
      "title": "Miroir magique",
      "avatarContentDescription": "Avatar",
      "wordOfTheDay": "Mot du jour",
      "playLipsync": "Lancer la synchronisation labiale",
      "noAvatarYet": "Pas encore d'avatar",
      "noAvatarDescription": "Créez un avatar 3D pour vous voir dans l'histoire",
      "createAvatar": "Créer un avatar"
    },
    "mode": {
      "title": "Mode avatar",
      "enableAvatarMode": "Activer le mode avatar",
      "enableDescription": "Montrez votre avatar réagissant au contenu",
      "avatarPreview": "Aperçu de l'avatar",
      "avatarPreviewContentDescription": "Aperçu de l'avatar",
      "noAvatarConfigured": "Aucun avatar configuré",
      "reactionStyle": "Style de réaction"
    },
    "wardrobe": {
      "title": "Garde-robe",
      "equippedContentDescription": "Équipé"
    },
    "settings": {
      "title": "Paramètres de l'avatar",
      "privacy": "Confidentialité",
      "privateAvatarMode": "Mode avatar privé",
      "privateAvatarDescription": "Masquer votre avatar des autres utilisateurs",
      "appearance": "Apparence",
      "enableAnimations": "Activer les animations",
      "animationsDescription": "Animer les mouvements et expressions de l'avatar",
      "availableOutfits": "Tenues disponibles"
    },
    "selfie": {
      "title": "Selfie vidéo",
      "camera": "Caméra",
      "cameraPreview": "Aperçu de la caméra",
      "startRecording": "Commencer l'enregistrement",
      "stopRecording": "Arrêter l'enregistrement",
      "rec": "REC",
      "enterPin": "Entrez votre code PIN pour créer un avatar",
      "pinLabel": "PIN",
      "retake": "Reprendre",
      "creatingAvatar": "Création de votre avatar...",
      "avatarCreated": "Avatar créé avec succès",
      "avatarPreviewContentDescription": "Aperçu de l'avatar",
      "createAnother": "Créer un autre"
    },
    "mesh": {
      "title": "Avatar 3D",
      "meshViewer": "Visionneuse de maillage 3D",
      "meshViewerDescription": "Le visualiseur de maillage 3D nécessite l'intégration de WebView ou GLSurfaceView",
      "skinTone": "Teint",
      "hairStyle": "Coiffure",
      "accessories": "Accessoires",
      "saveChanges": "Enregistrer les modifications"
    },
    "v2v": {
      "title": "Pratique vocale",
      "nextPhrase": "Phrase suivante",
      "stop": "Arrêter",
      "record": "Enregistrer",
      "mic": "MIC",
      "viewProgress": "Voir la progression",
      "analyzingPronunciation": "Analyse de la prononciation...",
      "pronunciationFeedback": "Retour sur la prononciation",
      "similarity": "Similarité : {{score}} %",
      "yourProgress": "Votre progression",
      "transforms": "Transformations : {{count}}",
      "improvement": "Amélioration : {{score}} %",
      "continuePracticing": "Continuer à pratiquer"
    },
    "characters": {
      "title": "Personnages",
      "noCharactersFound": "Aucun personnage trouvé pour ce film",
      "characterCount": "{{count}} personnages"
    },
    "interactions": {
      "title": "Interactions avec les films",
      "noInteractableMovies": "Aucun film interactif disponible"
    },
    "feedbackInbox": {
      "title": "Boîte de commentaires",
      "refreshContentDescription": "Actualiser",
      "noFeedbackYet": "Pas encore de commentaires",
      "feedbackAppearHere": "Les commentaires de vos contacts apparaîtront ici",
      "playVoiceMessage": "Écouter le message vocal"
    },
    "addContact": {
      "title": "Ajouter un contact",
      "nameLabel": "Nom",
      "phoneLabel": "Téléphone",
      "relationship": "Relation",
      "language": "Langue"
    },
    "avatar3d": {
      "title": "Avatar 3D",
      "glbMeshViewer": "Visionneuse de maillage GLB",
      "controls": "Commandes",
      "animate": "Animer",
      "vertices": "Sommets",
      "bones": "Os",
      "blendShapes": "Formes de fusion",
      "hasGlb": "Contient GLB",
      "status": "Statut : {{value}}"
    }
  }
}
